/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as TraceCodeRouteImport } from './routes/trace.$code'
import { Route as AppAuthedRouteImport } from './routes/_app/_authed'
import { Route as AppAuthedStationRouteImport } from './routes/_app/_authed/station'
import { Route as AppAuthedSaleRouteImport } from './routes/_app/_authed/sale'
import { Route as AppAuthedCustomerDisplayRouteImport } from './routes/_app/_authed/customer-display'
import { Route as AppAuthedSidebarRouteImport } from './routes/_app/_authed/_sidebar'
import { Route as AppAuthedSaleIndexRouteImport } from './routes/_app/_authed/sale.index'
import { Route as AppAuthedSidebarIndexRouteImport } from './routes/_app/_authed/_sidebar/index'
import { Route as AppAuthedSaleDisplayRouteImport } from './routes/_app/_authed/sale.display'
import { Route as AppAuthedSidebarWhatsNewRouteImport } from './routes/_app/_authed/_sidebar/whats-new'
import { Route as AppAuthedSidebarWarehouseStatsRouteImport } from './routes/_app/_authed/_sidebar/warehouse-stats'
import { Route as AppAuthedSidebarTrackingRouteImport } from './routes/_app/_authed/_sidebar/tracking'
import { Route as AppAuthedSidebarDevPlaygroundRouteImport } from './routes/_app/_authed/_sidebar/dev-playground'
import { Route as AppAuthedSidebarAgricultureRouteRouteImport } from './routes/_app/_authed/_sidebar/agriculture/route'
import { Route as AppAuthedSidebarWarehousePositionsIndexRouteImport } from './routes/_app/_authed/_sidebar/warehouse-positions/index'
import { Route as AppAuthedSidebarVehiclesIndexRouteImport } from './routes/_app/_authed/_sidebar/vehicles/index'
import { Route as AppAuthedSidebarUsersIndexRouteImport } from './routes/_app/_authed/_sidebar/users/index'
import { Route as AppAuthedSidebarTeaPurchasesIndexRouteImport } from './routes/_app/_authed/_sidebar/tea-purchases/index'
import { Route as AppAuthedSidebarStocktakeIndexRouteImport } from './routes/_app/_authed/_sidebar/stocktake/index'
import { Route as AppAuthedSidebarReportsIndexRouteImport } from './routes/_app/_authed/_sidebar/reports/index'
import { Route as AppAuthedSidebarProductsIndexRouteImport } from './routes/_app/_authed/_sidebar/products/index'
import { Route as AppAuthedSidebarPackagingIndexRouteImport } from './routes/_app/_authed/_sidebar/packaging/index'
import { Route as AppAuthedSidebarOrdersIndexRouteImport } from './routes/_app/_authed/_sidebar/orders/index'
import { Route as AppAuthedSidebarDeliveryTripsIndexRouteImport } from './routes/_app/_authed/_sidebar/delivery-trips.index'
import { Route as AppAuthedSidebarCustomersIndexRouteImport } from './routes/_app/_authed/_sidebar/customers/index'
import { Route as AppAuthedSidebarContractDeliveriesIndexRouteImport } from './routes/_app/_authed/_sidebar/contract-deliveries/index'
import { Route as AppAuthedSidebarAccountingIndexRouteImport } from './routes/_app/_authed/_sidebar/accounting/index'
import { Route as AppAuthedSidebarWarehouseSalesStatsRouteImport } from './routes/_app/_authed/_sidebar/warehouse-sales/stats'
import { Route as AppAuthedSidebarWarehouseSalesDefectsRouteImport } from './routes/_app/_authed/_sidebar/warehouse-sales/defects'
import { Route as AppAuthedSidebarWarehouseSalesDashboardRouteImport } from './routes/_app/_authed/_sidebar/warehouse-sales/dashboard'
import { Route as AppAuthedSidebarWarehousePositionsNewRouteImport } from './routes/_app/_authed/_sidebar/warehouse-positions/new'
import { Route as AppAuthedSidebarWarehousePositionsIdRouteImport } from './routes/_app/_authed/_sidebar/warehouse-positions/$id'
import { Route as AppAuthedSidebarVehiclesVehicleIdRouteImport } from './routes/_app/_authed/_sidebar/vehicles/$vehicleId'
import { Route as AppAuthedSidebarTeaPurchasesProcessingRouteImport } from './routes/_app/_authed/_sidebar/tea-purchases/processing'
import { Route as AppAuthedSidebarTeaPurchasesIdRouteImport } from './routes/_app/_authed/_sidebar/tea-purchases/$id'
import { Route as AppAuthedSidebarStocktakeNewRouteImport } from './routes/_app/_authed/_sidebar/stocktake/new'
import { Route as AppAuthedSidebarStocktakeIdRouteImport } from './routes/_app/_authed/_sidebar/stocktake/$id'
import { Route as AppAuthedSidebarSortingWarehouseTeaGradesRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/tea-grades'
import { Route as AppAuthedSidebarSortingWarehouseStatsRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stats'
import { Route as AppAuthedSidebarSettingsStationVoiceRouteImport } from './routes/_app/_authed/_sidebar/settings/station-voice'
import { Route as AppAuthedSidebarSettingsSlaRouteImport } from './routes/_app/_authed/_sidebar/settings/sla'
import { Route as AppAuthedSidebarSettingsSidebarLayoutRouteImport } from './routes/_app/_authed/_sidebar/settings/sidebar-layout'
import { Route as AppAuthedSidebarSettingsPrintingRouteImport } from './routes/_app/_authed/_sidebar/settings/printing'
import { Route as AppAuthedSidebarSettingsNotificationsRouteImport } from './routes/_app/_authed/_sidebar/settings/notifications'
import { Route as AppAuthedSidebarSettingsLotSizesRouteImport } from './routes/_app/_authed/_sidebar/settings/lot-sizes'
import { Route as AppAuthedSidebarSettingsInvoiceRouteImport } from './routes/_app/_authed/_sidebar/settings/invoice'
import { Route as AppAuthedSidebarScentingWarehouseStatsRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stats'
import { Route as AppAuthedSidebarPurchaseLotsStatsRouteImport } from './routes/_app/_authed/_sidebar/purchase-lots/stats'
import { Route as AppAuthedSidebarProductsNewRouteImport } from './routes/_app/_authed/_sidebar/products/new'
import { Route as AppAuthedSidebarProductsProductIdRouteImport } from './routes/_app/_authed/_sidebar/products/$productId'
import { Route as AppAuthedSidebarPackagingWarehouseStatsRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stats'
import { Route as AppAuthedSidebarOrdersQuickRouteImport } from './routes/_app/_authed/_sidebar/orders/quick'
import { Route as AppAuthedSidebarOrdersNewRouteImport } from './routes/_app/_authed/_sidebar/orders/new'
import { Route as AppAuthedSidebarOrdersOrderIdRouteImport } from './routes/_app/_authed/_sidebar/orders/$orderId'
import { Route as AppAuthedSidebarLogisticsShippingCarriersRouteImport } from './routes/_app/_authed/_sidebar/logistics/shipping-carriers'
import { Route as AppAuthedSidebarDriverCashRouteImport } from './routes/_app/_authed/_sidebar/driver/cash'
import { Route as AppAuthedSidebarDriverAvailableOrdersRouteImport } from './routes/_app/_authed/_sidebar/driver/available-orders'
import { Route as AppAuthedSidebarDeliveryTripsIdRouteImport } from './routes/_app/_authed/_sidebar/delivery-trips.$id'
import { Route as AppAuthedSidebarCustomersNewRouteImport } from './routes/_app/_authed/_sidebar/customers/new'
import { Route as AppAuthedSidebarCustomersCustomerIdRouteImport } from './routes/_app/_authed/_sidebar/customers/$customerId'
import { Route as AppAuthedSidebarContractDeliveriesNewRouteImport } from './routes/_app/_authed/_sidebar/contract-deliveries/new'
import { Route as AppAuthedSidebarContractDeliveriesIdRouteImport } from './routes/_app/_authed/_sidebar/contract-deliveries/$id'
import { Route as AppAuthedSidebarAgricultureWeighingsRouteImport } from './routes/_app/_authed/_sidebar/agriculture/weighings'
import { Route as AppAuthedSidebarAgricultureTeaTypesRouteImport } from './routes/_app/_authed/_sidebar/agriculture/tea-types'
import { Route as AppAuthedSidebarAgricultureTeaPackagesRouteImport } from './routes/_app/_authed/_sidebar/agriculture/tea-packages'
import { Route as AppAuthedSidebarAgricultureTeaLotsRouteImport } from './routes/_app/_authed/_sidebar/agriculture/tea-lots'
import { Route as AppAuthedSidebarAgricultureProductClassificationsRouteImport } from './routes/_app/_authed/_sidebar/agriculture/product-classifications'
import { Route as AppAuthedSidebarAgriculturePhasesRouteImport } from './routes/_app/_authed/_sidebar/agriculture/phases'
import { Route as AppAuthedSidebarAgriculturePesticidesRouteImport } from './routes/_app/_authed/_sidebar/agriculture/pesticides'
import { Route as AppAuthedSidebarAgricultureGrowersRouteImport } from './routes/_app/_authed/_sidebar/agriculture/growers'
import { Route as AppAuthedSidebarAgricultureFertilizersRouteImport } from './routes/_app/_authed/_sidebar/agriculture/fertilizers'
import { Route as AppAuthedSidebarAgricultureCareLogsRouteImport } from './routes/_app/_authed/_sidebar/agriculture/care-logs'
import { Route as AppAuthedSidebarAgricultureAromaSamplingsRouteImport } from './routes/_app/_authed/_sidebar/agriculture/aroma-samplings'
import { Route as AppAuthedSidebarAccountingRemittancesRouteImport } from './routes/_app/_authed/_sidebar/accounting/remittances'
import { Route as AppAuthedSidebarAccountingReconciliationRouteImport } from './routes/_app/_authed/_sidebar/accounting/reconciliation'
import { Route as AppAuthedSidebarAccountingExpensesRouteImport } from './routes/_app/_authed/_sidebar/accounting/expenses'
import { Route as AppAuthedSidebarAccountingExpenseSyncRouteImport } from './routes/_app/_authed/_sidebar/accounting/expense-sync'
import { Route as AppAuthedSidebarAccountingExpenseCategoriesRouteImport } from './routes/_app/_authed/_sidebar/accounting/expense-categories'
import { Route as AppAuthedSidebarAccountingCashFlowRouteImport } from './routes/_app/_authed/_sidebar/accounting/cash-flow'
import { Route as AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/index'
import { Route as AppAuthedSidebarSortingWarehouseStockOutNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/index'
import { Route as AppAuthedSidebarSortingWarehouseStockInNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/index'
import { Route as AppAuthedSidebarSortingWarehouseLotsIndexRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/lots/index'
import { Route as AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/index'
import { Route as AppAuthedSidebarScentingWarehouseStockOutNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/index'
import { Route as AppAuthedSidebarScentingWarehouseStockInNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/index'
import { Route as AppAuthedSidebarScentingWarehouseLotsIndexRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/lots/index'
import { Route as AppAuthedSidebarSalesWarehouseStockOutNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/index'
import { Route as AppAuthedSidebarSalesWarehouseStockInNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/index'
import { Route as AppAuthedSidebarSalesWarehouseLotsIndexRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/lots/index'
import { Route as AppAuthedSidebarPurchaseLotsWithdrawalNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/purchase-lots/withdrawal-notes/index'
import { Route as AppAuthedSidebarPurchaseLotsStockOutNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/purchase-lots/stock-out-notes/index'
import { Route as AppAuthedSidebarPurchaseLotsStockInNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/purchase-lots/stock-in-notes/index'
import { Route as AppAuthedSidebarPurchaseLotsLotsIndexRouteImport } from './routes/_app/_authed/_sidebar/purchase-lots/lots/index'
import { Route as AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/index'
import { Route as AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/index'
import { Route as AppAuthedSidebarPackagingWarehouseStockInNotesIndexRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/index'
import { Route as AppAuthedSidebarPackagingWarehouseLotsIndexRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/lots/index'
import { Route as AppAuthedSidebarCustomersGroupsIndexRouteImport } from './routes/_app/_authed/_sidebar/customers/groups/index'
import { Route as AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/new'
import { Route as AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/$id'
import { Route as AppAuthedSidebarSortingWarehouseStockOutNotesNewRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/new'
import { Route as AppAuthedSidebarSortingWarehouseStockOutNotesIdRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id'
import { Route as AppAuthedSidebarSortingWarehouseStockInNotesNewRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/new'
import { Route as AppAuthedSidebarSortingWarehouseStockInNotesIdRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id'
import { Route as AppAuthedSidebarSortingWarehouseLotsIdRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/lots/$id'
import { Route as AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/new'
import { Route as AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/$id'
import { Route as AppAuthedSidebarScentingWarehouseStockOutNotesNewRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/new'
import { Route as AppAuthedSidebarScentingWarehouseStockOutNotesIdRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id'
import { Route as AppAuthedSidebarScentingWarehouseStockInNotesNewRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/new'
import { Route as AppAuthedSidebarScentingWarehouseStockInNotesIdRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id'
import { Route as AppAuthedSidebarScentingWarehouseLotsIdRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/lots/$id'
import { Route as AppAuthedSidebarSalesWarehouseStockOutNotesNewRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/new'
import { Route as AppAuthedSidebarSalesWarehouseStockOutNotesIdRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id'
import { Route as AppAuthedSidebarSalesWarehouseStockInNotesQuickRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/quick'
import { Route as AppAuthedSidebarSalesWarehouseStockInNotesNewRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/new'
import { Route as AppAuthedSidebarSalesWarehouseStockInNotesIdRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id'
import { Route as AppAuthedSidebarSalesWarehouseLotsIdRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/lots/$id'
import { Route as AppAuthedSidebarPurchaseLotsWithdrawalNotesNewRouteImport } from './routes/_app/_authed/_sidebar/purchase-lots/withdrawal-notes/new'
import { Route as AppAuthedSidebarPurchaseLotsWithdrawalNotesIdRouteImport } from './routes/_app/_authed/_sidebar/purchase-lots/withdrawal-notes/$id'
import { Route as AppAuthedSidebarPurchaseLotsStockOutNotesNewRouteImport } from './routes/_app/_authed/_sidebar/purchase-lots/stock-out-notes/new'
import { Route as AppAuthedSidebarPurchaseLotsStockOutNotesIdRouteImport } from './routes/_app/_authed/_sidebar/purchase-lots/stock-out-notes/$id'
import { Route as AppAuthedSidebarPurchaseLotsStockInNotesNewRouteImport } from './routes/_app/_authed/_sidebar/purchase-lots/stock-in-notes/new'
import { Route as AppAuthedSidebarPurchaseLotsStockInNotesIdRouteImport } from './routes/_app/_authed/_sidebar/purchase-lots/stock-in-notes/$id'
import { Route as AppAuthedSidebarPurchaseLotsLotsIdRouteImport } from './routes/_app/_authed/_sidebar/purchase-lots/lots/$id'
import { Route as AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/new'
import { Route as AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/$id'
import { Route as AppAuthedSidebarPackagingWarehouseStockOutNotesNewRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/new'
import { Route as AppAuthedSidebarPackagingWarehouseStockOutNotesIdRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id'
import { Route as AppAuthedSidebarPackagingWarehouseStockInNotesNewRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/new'
import { Route as AppAuthedSidebarPackagingWarehouseStockInNotesIdRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id'
import { Route as AppAuthedSidebarPackagingWarehouseLotsIdRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/lots/$id'
import { Route as AppAuthedSidebarCustomersGroupsGroupIdRouteImport } from './routes/_app/_authed/_sidebar/customers/groups/$groupId'
import { Route as AppAuthedSidebarAccountingReportsDailyRouteImport } from './routes/_app/_authed/_sidebar/accounting/reports/daily'
import { Route as AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id_.edit'
import { Route as AppAuthedSidebarSortingWarehouseStockInNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id_.edit'
import { Route as AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id_.edit'
import { Route as AppAuthedSidebarScentingWarehouseStockInNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id_.edit'
import { Route as AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id_.edit'
import { Route as AppAuthedSidebarSalesWarehouseStockInNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id_.edit'
import { Route as AppAuthedSidebarPurchaseLotsStockOutNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/purchase-lots/stock-out-notes/$id_.edit'
import { Route as AppAuthedSidebarPurchaseLotsStockInNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/purchase-lots/stock-in-notes/$id_.edit'
import { Route as AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id_.edit'
import { Route as AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRouteImport } from './routes/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id_.edit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const TraceCodeRoute = TraceCodeRouteImport.update({
  id: '/trace/$code',
  path: '/trace/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAuthedRoute = AppAuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => AppRoute,
} as any)
const AppAuthedStationRoute = AppAuthedStationRouteImport.update({
  id: '/station',
  path: '/station',
  getParentRoute: () => AppAuthedRoute,
} as any)
const AppAuthedSaleRoute = AppAuthedSaleRouteImport.update({
  id: '/sale',
  path: '/sale',
  getParentRoute: () => AppAuthedRoute,
} as any)
const AppAuthedCustomerDisplayRoute =
  AppAuthedCustomerDisplayRouteImport.update({
    id: '/customer-display',
    path: '/customer-display',
    getParentRoute: () => AppAuthedRoute,
  } as any)
const AppAuthedSidebarRoute = AppAuthedSidebarRouteImport.update({
  id: '/_sidebar',
  getParentRoute: () => AppAuthedRoute,
} as any)
const AppAuthedSaleIndexRoute = AppAuthedSaleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAuthedSaleRoute,
} as any)
const AppAuthedSidebarIndexRoute = AppAuthedSidebarIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAuthedSidebarRoute,
} as any)
const AppAuthedSaleDisplayRoute = AppAuthedSaleDisplayRouteImport.update({
  id: '/display',
  path: '/display',
  getParentRoute: () => AppAuthedSaleRoute,
} as any)
const AppAuthedSidebarWhatsNewRoute =
  AppAuthedSidebarWhatsNewRouteImport.update({
    id: '/whats-new',
    path: '/whats-new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWarehouseStatsRoute =
  AppAuthedSidebarWarehouseStatsRouteImport.update({
    id: '/warehouse-stats',
    path: '/warehouse-stats',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarTrackingRoute =
  AppAuthedSidebarTrackingRouteImport.update({
    id: '/tracking',
    path: '/tracking',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarDevPlaygroundRoute =
  AppAuthedSidebarDevPlaygroundRouteImport.update({
    id: '/dev-playground',
    path: '/dev-playground',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgricultureRouteRoute =
  AppAuthedSidebarAgricultureRouteRouteImport.update({
    id: '/agriculture',
    path: '/agriculture',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWarehousePositionsIndexRoute =
  AppAuthedSidebarWarehousePositionsIndexRouteImport.update({
    id: '/warehouse-positions/',
    path: '/warehouse-positions/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarVehiclesIndexRoute =
  AppAuthedSidebarVehiclesIndexRouteImport.update({
    id: '/vehicles/',
    path: '/vehicles/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarUsersIndexRoute =
  AppAuthedSidebarUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarTeaPurchasesIndexRoute =
  AppAuthedSidebarTeaPurchasesIndexRouteImport.update({
    id: '/tea-purchases/',
    path: '/tea-purchases/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarStocktakeIndexRoute =
  AppAuthedSidebarStocktakeIndexRouteImport.update({
    id: '/stocktake/',
    path: '/stocktake/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarReportsIndexRoute =
  AppAuthedSidebarReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarProductsIndexRoute =
  AppAuthedSidebarProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingIndexRoute =
  AppAuthedSidebarPackagingIndexRouteImport.update({
    id: '/packaging/',
    path: '/packaging/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarOrdersIndexRoute =
  AppAuthedSidebarOrdersIndexRouteImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarDeliveryTripsIndexRoute =
  AppAuthedSidebarDeliveryTripsIndexRouteImport.update({
    id: '/delivery-trips/',
    path: '/delivery-trips/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarCustomersIndexRoute =
  AppAuthedSidebarCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarContractDeliveriesIndexRoute =
  AppAuthedSidebarContractDeliveriesIndexRouteImport.update({
    id: '/contract-deliveries/',
    path: '/contract-deliveries/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAccountingIndexRoute =
  AppAuthedSidebarAccountingIndexRouteImport.update({
    id: '/accounting/',
    path: '/accounting/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWarehouseSalesStatsRoute =
  AppAuthedSidebarWarehouseSalesStatsRouteImport.update({
    id: '/warehouse-sales/stats',
    path: '/warehouse-sales/stats',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWarehouseSalesDefectsRoute =
  AppAuthedSidebarWarehouseSalesDefectsRouteImport.update({
    id: '/warehouse-sales/defects',
    path: '/warehouse-sales/defects',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWarehouseSalesDashboardRoute =
  AppAuthedSidebarWarehouseSalesDashboardRouteImport.update({
    id: '/warehouse-sales/dashboard',
    path: '/warehouse-sales/dashboard',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWarehousePositionsNewRoute =
  AppAuthedSidebarWarehousePositionsNewRouteImport.update({
    id: '/warehouse-positions/new',
    path: '/warehouse-positions/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarWarehousePositionsIdRoute =
  AppAuthedSidebarWarehousePositionsIdRouteImport.update({
    id: '/warehouse-positions/$id',
    path: '/warehouse-positions/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarVehiclesVehicleIdRoute =
  AppAuthedSidebarVehiclesVehicleIdRouteImport.update({
    id: '/vehicles/$vehicleId',
    path: '/vehicles/$vehicleId',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarTeaPurchasesProcessingRoute =
  AppAuthedSidebarTeaPurchasesProcessingRouteImport.update({
    id: '/tea-purchases/processing',
    path: '/tea-purchases/processing',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarTeaPurchasesIdRoute =
  AppAuthedSidebarTeaPurchasesIdRouteImport.update({
    id: '/tea-purchases/$id',
    path: '/tea-purchases/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarStocktakeNewRoute =
  AppAuthedSidebarStocktakeNewRouteImport.update({
    id: '/stocktake/new',
    path: '/stocktake/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarStocktakeIdRoute =
  AppAuthedSidebarStocktakeIdRouteImport.update({
    id: '/stocktake/$id',
    path: '/stocktake/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseTeaGradesRoute =
  AppAuthedSidebarSortingWarehouseTeaGradesRouteImport.update({
    id: '/sorting-warehouse/tea-grades',
    path: '/sorting-warehouse/tea-grades',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStatsRoute =
  AppAuthedSidebarSortingWarehouseStatsRouteImport.update({
    id: '/sorting-warehouse/stats',
    path: '/sorting-warehouse/stats',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsStationVoiceRoute =
  AppAuthedSidebarSettingsStationVoiceRouteImport.update({
    id: '/settings/station-voice',
    path: '/settings/station-voice',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsSlaRoute =
  AppAuthedSidebarSettingsSlaRouteImport.update({
    id: '/settings/sla',
    path: '/settings/sla',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsSidebarLayoutRoute =
  AppAuthedSidebarSettingsSidebarLayoutRouteImport.update({
    id: '/settings/sidebar-layout',
    path: '/settings/sidebar-layout',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsPrintingRoute =
  AppAuthedSidebarSettingsPrintingRouteImport.update({
    id: '/settings/printing',
    path: '/settings/printing',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsNotificationsRoute =
  AppAuthedSidebarSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsLotSizesRoute =
  AppAuthedSidebarSettingsLotSizesRouteImport.update({
    id: '/settings/lot-sizes',
    path: '/settings/lot-sizes',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSettingsInvoiceRoute =
  AppAuthedSidebarSettingsInvoiceRouteImport.update({
    id: '/settings/invoice',
    path: '/settings/invoice',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStatsRoute =
  AppAuthedSidebarScentingWarehouseStatsRouteImport.update({
    id: '/scenting-warehouse/stats',
    path: '/scenting-warehouse/stats',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPurchaseLotsStatsRoute =
  AppAuthedSidebarPurchaseLotsStatsRouteImport.update({
    id: '/purchase-lots/stats',
    path: '/purchase-lots/stats',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarProductsNewRoute =
  AppAuthedSidebarProductsNewRouteImport.update({
    id: '/products/new',
    path: '/products/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarProductsProductIdRoute =
  AppAuthedSidebarProductsProductIdRouteImport.update({
    id: '/products/$productId',
    path: '/products/$productId',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStatsRoute =
  AppAuthedSidebarPackagingWarehouseStatsRouteImport.update({
    id: '/packaging-warehouse/stats',
    path: '/packaging-warehouse/stats',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarOrdersQuickRoute =
  AppAuthedSidebarOrdersQuickRouteImport.update({
    id: '/orders/quick',
    path: '/orders/quick',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarOrdersNewRoute =
  AppAuthedSidebarOrdersNewRouteImport.update({
    id: '/orders/new',
    path: '/orders/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarOrdersOrderIdRoute =
  AppAuthedSidebarOrdersOrderIdRouteImport.update({
    id: '/orders/$orderId',
    path: '/orders/$orderId',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarLogisticsShippingCarriersRoute =
  AppAuthedSidebarLogisticsShippingCarriersRouteImport.update({
    id: '/logistics/shipping-carriers',
    path: '/logistics/shipping-carriers',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarDriverCashRoute =
  AppAuthedSidebarDriverCashRouteImport.update({
    id: '/driver/cash',
    path: '/driver/cash',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarDriverAvailableOrdersRoute =
  AppAuthedSidebarDriverAvailableOrdersRouteImport.update({
    id: '/driver/available-orders',
    path: '/driver/available-orders',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarDeliveryTripsIdRoute =
  AppAuthedSidebarDeliveryTripsIdRouteImport.update({
    id: '/delivery-trips/$id',
    path: '/delivery-trips/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarCustomersNewRoute =
  AppAuthedSidebarCustomersNewRouteImport.update({
    id: '/customers/new',
    path: '/customers/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarCustomersCustomerIdRoute =
  AppAuthedSidebarCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarContractDeliveriesNewRoute =
  AppAuthedSidebarContractDeliveriesNewRouteImport.update({
    id: '/contract-deliveries/new',
    path: '/contract-deliveries/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarContractDeliveriesIdRoute =
  AppAuthedSidebarContractDeliveriesIdRouteImport.update({
    id: '/contract-deliveries/$id',
    path: '/contract-deliveries/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAgricultureWeighingsRoute =
  AppAuthedSidebarAgricultureWeighingsRouteImport.update({
    id: '/weighings',
    path: '/weighings',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureTeaTypesRoute =
  AppAuthedSidebarAgricultureTeaTypesRouteImport.update({
    id: '/tea-types',
    path: '/tea-types',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureTeaPackagesRoute =
  AppAuthedSidebarAgricultureTeaPackagesRouteImport.update({
    id: '/tea-packages',
    path: '/tea-packages',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureTeaLotsRoute =
  AppAuthedSidebarAgricultureTeaLotsRouteImport.update({
    id: '/tea-lots',
    path: '/tea-lots',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureProductClassificationsRoute =
  AppAuthedSidebarAgricultureProductClassificationsRouteImport.update({
    id: '/product-classifications',
    path: '/product-classifications',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgriculturePhasesRoute =
  AppAuthedSidebarAgriculturePhasesRouteImport.update({
    id: '/phases',
    path: '/phases',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgriculturePesticidesRoute =
  AppAuthedSidebarAgriculturePesticidesRouteImport.update({
    id: '/pesticides',
    path: '/pesticides',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureGrowersRoute =
  AppAuthedSidebarAgricultureGrowersRouteImport.update({
    id: '/growers',
    path: '/growers',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureFertilizersRoute =
  AppAuthedSidebarAgricultureFertilizersRouteImport.update({
    id: '/fertilizers',
    path: '/fertilizers',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureCareLogsRoute =
  AppAuthedSidebarAgricultureCareLogsRouteImport.update({
    id: '/care-logs',
    path: '/care-logs',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAgricultureAromaSamplingsRoute =
  AppAuthedSidebarAgricultureAromaSamplingsRouteImport.update({
    id: '/aroma-samplings',
    path: '/aroma-samplings',
    getParentRoute: () => AppAuthedSidebarAgricultureRouteRoute,
  } as any)
const AppAuthedSidebarAccountingRemittancesRoute =
  AppAuthedSidebarAccountingRemittancesRouteImport.update({
    id: '/accounting/remittances',
    path: '/accounting/remittances',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAccountingReconciliationRoute =
  AppAuthedSidebarAccountingReconciliationRouteImport.update({
    id: '/accounting/reconciliation',
    path: '/accounting/reconciliation',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAccountingExpensesRoute =
  AppAuthedSidebarAccountingExpensesRouteImport.update({
    id: '/accounting/expenses',
    path: '/accounting/expenses',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAccountingExpenseSyncRoute =
  AppAuthedSidebarAccountingExpenseSyncRouteImport.update({
    id: '/accounting/expense-sync',
    path: '/accounting/expense-sync',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAccountingExpenseCategoriesRoute =
  AppAuthedSidebarAccountingExpenseCategoriesRouteImport.update({
    id: '/accounting/expense-categories',
    path: '/accounting/expense-categories',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAccountingCashFlowRoute =
  AppAuthedSidebarAccountingCashFlowRouteImport.update({
    id: '/accounting/cash-flow',
    path: '/accounting/cash-flow',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRoute =
  AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRouteImport.update({
    id: '/sorting-warehouse/withdrawal-notes/',
    path: '/sorting-warehouse/withdrawal-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStockOutNotesIndexRoute =
  AppAuthedSidebarSortingWarehouseStockOutNotesIndexRouteImport.update({
    id: '/sorting-warehouse/stock-out-notes/',
    path: '/sorting-warehouse/stock-out-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStockInNotesIndexRoute =
  AppAuthedSidebarSortingWarehouseStockInNotesIndexRouteImport.update({
    id: '/sorting-warehouse/stock-in-notes/',
    path: '/sorting-warehouse/stock-in-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseLotsIndexRoute =
  AppAuthedSidebarSortingWarehouseLotsIndexRouteImport.update({
    id: '/sorting-warehouse/lots/',
    path: '/sorting-warehouse/lots/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRoute =
  AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRouteImport.update({
    id: '/scenting-warehouse/withdrawal-notes/',
    path: '/scenting-warehouse/withdrawal-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStockOutNotesIndexRoute =
  AppAuthedSidebarScentingWarehouseStockOutNotesIndexRouteImport.update({
    id: '/scenting-warehouse/stock-out-notes/',
    path: '/scenting-warehouse/stock-out-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStockInNotesIndexRoute =
  AppAuthedSidebarScentingWarehouseStockInNotesIndexRouteImport.update({
    id: '/scenting-warehouse/stock-in-notes/',
    path: '/scenting-warehouse/stock-in-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseLotsIndexRoute =
  AppAuthedSidebarScentingWarehouseLotsIndexRouteImport.update({
    id: '/scenting-warehouse/lots/',
    path: '/scenting-warehouse/lots/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockOutNotesIndexRoute =
  AppAuthedSidebarSalesWarehouseStockOutNotesIndexRouteImport.update({
    id: '/sales-warehouse/stock-out-notes/',
    path: '/sales-warehouse/stock-out-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockInNotesIndexRoute =
  AppAuthedSidebarSalesWarehouseStockInNotesIndexRouteImport.update({
    id: '/sales-warehouse/stock-in-notes/',
    path: '/sales-warehouse/stock-in-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseLotsIndexRoute =
  AppAuthedSidebarSalesWarehouseLotsIndexRouteImport.update({
    id: '/sales-warehouse/lots/',
    path: '/sales-warehouse/lots/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPurchaseLotsWithdrawalNotesIndexRoute =
  AppAuthedSidebarPurchaseLotsWithdrawalNotesIndexRouteImport.update({
    id: '/purchase-lots/withdrawal-notes/',
    path: '/purchase-lots/withdrawal-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPurchaseLotsStockOutNotesIndexRoute =
  AppAuthedSidebarPurchaseLotsStockOutNotesIndexRouteImport.update({
    id: '/purchase-lots/stock-out-notes/',
    path: '/purchase-lots/stock-out-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPurchaseLotsStockInNotesIndexRoute =
  AppAuthedSidebarPurchaseLotsStockInNotesIndexRouteImport.update({
    id: '/purchase-lots/stock-in-notes/',
    path: '/purchase-lots/stock-in-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPurchaseLotsLotsIndexRoute =
  AppAuthedSidebarPurchaseLotsLotsIndexRouteImport.update({
    id: '/purchase-lots/lots/',
    path: '/purchase-lots/lots/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRoute =
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRouteImport.update({
    id: '/packaging-warehouse/withdrawal-notes/',
    path: '/packaging-warehouse/withdrawal-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRoute =
  AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRouteImport.update({
    id: '/packaging-warehouse/stock-out-notes/',
    path: '/packaging-warehouse/stock-out-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStockInNotesIndexRoute =
  AppAuthedSidebarPackagingWarehouseStockInNotesIndexRouteImport.update({
    id: '/packaging-warehouse/stock-in-notes/',
    path: '/packaging-warehouse/stock-in-notes/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseLotsIndexRoute =
  AppAuthedSidebarPackagingWarehouseLotsIndexRouteImport.update({
    id: '/packaging-warehouse/lots/',
    path: '/packaging-warehouse/lots/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarCustomersGroupsIndexRoute =
  AppAuthedSidebarCustomersGroupsIndexRouteImport.update({
    id: '/customers/groups/',
    path: '/customers/groups/',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRoute =
  AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRouteImport.update({
    id: '/sorting-warehouse/withdrawal-notes/new',
    path: '/sorting-warehouse/withdrawal-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRoute =
  AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRouteImport.update({
    id: '/sorting-warehouse/withdrawal-notes/$id',
    path: '/sorting-warehouse/withdrawal-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStockOutNotesNewRoute =
  AppAuthedSidebarSortingWarehouseStockOutNotesNewRouteImport.update({
    id: '/sorting-warehouse/stock-out-notes/new',
    path: '/sorting-warehouse/stock-out-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStockOutNotesIdRoute =
  AppAuthedSidebarSortingWarehouseStockOutNotesIdRouteImport.update({
    id: '/sorting-warehouse/stock-out-notes/$id',
    path: '/sorting-warehouse/stock-out-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStockInNotesNewRoute =
  AppAuthedSidebarSortingWarehouseStockInNotesNewRouteImport.update({
    id: '/sorting-warehouse/stock-in-notes/new',
    path: '/sorting-warehouse/stock-in-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStockInNotesIdRoute =
  AppAuthedSidebarSortingWarehouseStockInNotesIdRouteImport.update({
    id: '/sorting-warehouse/stock-in-notes/$id',
    path: '/sorting-warehouse/stock-in-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseLotsIdRoute =
  AppAuthedSidebarSortingWarehouseLotsIdRouteImport.update({
    id: '/sorting-warehouse/lots/$id',
    path: '/sorting-warehouse/lots/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRoute =
  AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRouteImport.update({
    id: '/scenting-warehouse/withdrawal-notes/new',
    path: '/scenting-warehouse/withdrawal-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRoute =
  AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRouteImport.update({
    id: '/scenting-warehouse/withdrawal-notes/$id',
    path: '/scenting-warehouse/withdrawal-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStockOutNotesNewRoute =
  AppAuthedSidebarScentingWarehouseStockOutNotesNewRouteImport.update({
    id: '/scenting-warehouse/stock-out-notes/new',
    path: '/scenting-warehouse/stock-out-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStockOutNotesIdRoute =
  AppAuthedSidebarScentingWarehouseStockOutNotesIdRouteImport.update({
    id: '/scenting-warehouse/stock-out-notes/$id',
    path: '/scenting-warehouse/stock-out-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStockInNotesNewRoute =
  AppAuthedSidebarScentingWarehouseStockInNotesNewRouteImport.update({
    id: '/scenting-warehouse/stock-in-notes/new',
    path: '/scenting-warehouse/stock-in-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStockInNotesIdRoute =
  AppAuthedSidebarScentingWarehouseStockInNotesIdRouteImport.update({
    id: '/scenting-warehouse/stock-in-notes/$id',
    path: '/scenting-warehouse/stock-in-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseLotsIdRoute =
  AppAuthedSidebarScentingWarehouseLotsIdRouteImport.update({
    id: '/scenting-warehouse/lots/$id',
    path: '/scenting-warehouse/lots/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockOutNotesNewRoute =
  AppAuthedSidebarSalesWarehouseStockOutNotesNewRouteImport.update({
    id: '/sales-warehouse/stock-out-notes/new',
    path: '/sales-warehouse/stock-out-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockOutNotesIdRoute =
  AppAuthedSidebarSalesWarehouseStockOutNotesIdRouteImport.update({
    id: '/sales-warehouse/stock-out-notes/$id',
    path: '/sales-warehouse/stock-out-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockInNotesQuickRoute =
  AppAuthedSidebarSalesWarehouseStockInNotesQuickRouteImport.update({
    id: '/sales-warehouse/stock-in-notes/quick',
    path: '/sales-warehouse/stock-in-notes/quick',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockInNotesNewRoute =
  AppAuthedSidebarSalesWarehouseStockInNotesNewRouteImport.update({
    id: '/sales-warehouse/stock-in-notes/new',
    path: '/sales-warehouse/stock-in-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockInNotesIdRoute =
  AppAuthedSidebarSalesWarehouseStockInNotesIdRouteImport.update({
    id: '/sales-warehouse/stock-in-notes/$id',
    path: '/sales-warehouse/stock-in-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseLotsIdRoute =
  AppAuthedSidebarSalesWarehouseLotsIdRouteImport.update({
    id: '/sales-warehouse/lots/$id',
    path: '/sales-warehouse/lots/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPurchaseLotsWithdrawalNotesNewRoute =
  AppAuthedSidebarPurchaseLotsWithdrawalNotesNewRouteImport.update({
    id: '/purchase-lots/withdrawal-notes/new',
    path: '/purchase-lots/withdrawal-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPurchaseLotsWithdrawalNotesIdRoute =
  AppAuthedSidebarPurchaseLotsWithdrawalNotesIdRouteImport.update({
    id: '/purchase-lots/withdrawal-notes/$id',
    path: '/purchase-lots/withdrawal-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPurchaseLotsStockOutNotesNewRoute =
  AppAuthedSidebarPurchaseLotsStockOutNotesNewRouteImport.update({
    id: '/purchase-lots/stock-out-notes/new',
    path: '/purchase-lots/stock-out-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPurchaseLotsStockOutNotesIdRoute =
  AppAuthedSidebarPurchaseLotsStockOutNotesIdRouteImport.update({
    id: '/purchase-lots/stock-out-notes/$id',
    path: '/purchase-lots/stock-out-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPurchaseLotsStockInNotesNewRoute =
  AppAuthedSidebarPurchaseLotsStockInNotesNewRouteImport.update({
    id: '/purchase-lots/stock-in-notes/new',
    path: '/purchase-lots/stock-in-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPurchaseLotsStockInNotesIdRoute =
  AppAuthedSidebarPurchaseLotsStockInNotesIdRouteImport.update({
    id: '/purchase-lots/stock-in-notes/$id',
    path: '/purchase-lots/stock-in-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPurchaseLotsLotsIdRoute =
  AppAuthedSidebarPurchaseLotsLotsIdRouteImport.update({
    id: '/purchase-lots/lots/$id',
    path: '/purchase-lots/lots/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRoute =
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRouteImport.update({
    id: '/packaging-warehouse/withdrawal-notes/new',
    path: '/packaging-warehouse/withdrawal-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRoute =
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRouteImport.update({
    id: '/packaging-warehouse/withdrawal-notes/$id',
    path: '/packaging-warehouse/withdrawal-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStockOutNotesNewRoute =
  AppAuthedSidebarPackagingWarehouseStockOutNotesNewRouteImport.update({
    id: '/packaging-warehouse/stock-out-notes/new',
    path: '/packaging-warehouse/stock-out-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStockOutNotesIdRoute =
  AppAuthedSidebarPackagingWarehouseStockOutNotesIdRouteImport.update({
    id: '/packaging-warehouse/stock-out-notes/$id',
    path: '/packaging-warehouse/stock-out-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStockInNotesNewRoute =
  AppAuthedSidebarPackagingWarehouseStockInNotesNewRouteImport.update({
    id: '/packaging-warehouse/stock-in-notes/new',
    path: '/packaging-warehouse/stock-in-notes/new',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStockInNotesIdRoute =
  AppAuthedSidebarPackagingWarehouseStockInNotesIdRouteImport.update({
    id: '/packaging-warehouse/stock-in-notes/$id',
    path: '/packaging-warehouse/stock-in-notes/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseLotsIdRoute =
  AppAuthedSidebarPackagingWarehouseLotsIdRouteImport.update({
    id: '/packaging-warehouse/lots/$id',
    path: '/packaging-warehouse/lots/$id',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarCustomersGroupsGroupIdRoute =
  AppAuthedSidebarCustomersGroupsGroupIdRouteImport.update({
    id: '/customers/groups/$groupId',
    path: '/customers/groups/$groupId',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarAccountingReportsDailyRoute =
  AppAuthedSidebarAccountingReportsDailyRouteImport.update({
    id: '/accounting/reports/daily',
    path: '/accounting/reports/daily',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRoute =
  AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRouteImport.update({
    id: '/sorting-warehouse/stock-out-notes/$id_/edit',
    path: '/sorting-warehouse/stock-out-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSortingWarehouseStockInNotesIdEditRoute =
  AppAuthedSidebarSortingWarehouseStockInNotesIdEditRouteImport.update({
    id: '/sorting-warehouse/stock-in-notes/$id_/edit',
    path: '/sorting-warehouse/stock-in-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRoute =
  AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRouteImport.update({
    id: '/scenting-warehouse/stock-out-notes/$id_/edit',
    path: '/scenting-warehouse/stock-out-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarScentingWarehouseStockInNotesIdEditRoute =
  AppAuthedSidebarScentingWarehouseStockInNotesIdEditRouteImport.update({
    id: '/scenting-warehouse/stock-in-notes/$id_/edit',
    path: '/scenting-warehouse/stock-in-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRoute =
  AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRouteImport.update({
    id: '/sales-warehouse/stock-out-notes/$id_/edit',
    path: '/sales-warehouse/stock-out-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarSalesWarehouseStockInNotesIdEditRoute =
  AppAuthedSidebarSalesWarehouseStockInNotesIdEditRouteImport.update({
    id: '/sales-warehouse/stock-in-notes/$id_/edit',
    path: '/sales-warehouse/stock-in-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPurchaseLotsStockOutNotesIdEditRoute =
  AppAuthedSidebarPurchaseLotsStockOutNotesIdEditRouteImport.update({
    id: '/purchase-lots/stock-out-notes/$id_/edit',
    path: '/purchase-lots/stock-out-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPurchaseLotsStockInNotesIdEditRoute =
  AppAuthedSidebarPurchaseLotsStockInNotesIdEditRouteImport.update({
    id: '/purchase-lots/stock-in-notes/$id_/edit',
    path: '/purchase-lots/stock-in-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRoute =
  AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRouteImport.update({
    id: '/packaging-warehouse/stock-out-notes/$id_/edit',
    path: '/packaging-warehouse/stock-out-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)
const AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRoute =
  AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRouteImport.update({
    id: '/packaging-warehouse/stock-in-notes/$id_/edit',
    path: '/packaging-warehouse/stock-in-notes/$id/edit',
    getParentRoute: () => AppAuthedSidebarRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppAuthedSidebarIndexRoute
  '/login': typeof LoginRoute
  '/trace/$code': typeof TraceCodeRoute
  '/customer-display': typeof AppAuthedCustomerDisplayRoute
  '/sale': typeof AppAuthedSaleRouteWithChildren
  '/station': typeof AppAuthedStationRoute
  '/agriculture': typeof AppAuthedSidebarAgricultureRouteRouteWithChildren
  '/dev-playground': typeof AppAuthedSidebarDevPlaygroundRoute
  '/tracking': typeof AppAuthedSidebarTrackingRoute
  '/warehouse-stats': typeof AppAuthedSidebarWarehouseStatsRoute
  '/whats-new': typeof AppAuthedSidebarWhatsNewRoute
  '/sale/display': typeof AppAuthedSaleDisplayRoute
  '/sale/': typeof AppAuthedSaleIndexRoute
  '/accounting/cash-flow': typeof AppAuthedSidebarAccountingCashFlowRoute
  '/accounting/expense-categories': typeof AppAuthedSidebarAccountingExpenseCategoriesRoute
  '/accounting/expense-sync': typeof AppAuthedSidebarAccountingExpenseSyncRoute
  '/accounting/expenses': typeof AppAuthedSidebarAccountingExpensesRoute
  '/accounting/reconciliation': typeof AppAuthedSidebarAccountingReconciliationRoute
  '/accounting/remittances': typeof AppAuthedSidebarAccountingRemittancesRoute
  '/agriculture/aroma-samplings': typeof AppAuthedSidebarAgricultureAromaSamplingsRoute
  '/agriculture/care-logs': typeof AppAuthedSidebarAgricultureCareLogsRoute
  '/agriculture/fertilizers': typeof AppAuthedSidebarAgricultureFertilizersRoute
  '/agriculture/growers': typeof AppAuthedSidebarAgricultureGrowersRoute
  '/agriculture/pesticides': typeof AppAuthedSidebarAgriculturePesticidesRoute
  '/agriculture/phases': typeof AppAuthedSidebarAgriculturePhasesRoute
  '/agriculture/product-classifications': typeof AppAuthedSidebarAgricultureProductClassificationsRoute
  '/agriculture/tea-lots': typeof AppAuthedSidebarAgricultureTeaLotsRoute
  '/agriculture/tea-packages': typeof AppAuthedSidebarAgricultureTeaPackagesRoute
  '/agriculture/tea-types': typeof AppAuthedSidebarAgricultureTeaTypesRoute
  '/agriculture/weighings': typeof AppAuthedSidebarAgricultureWeighingsRoute
  '/contract-deliveries/$id': typeof AppAuthedSidebarContractDeliveriesIdRoute
  '/contract-deliveries/new': typeof AppAuthedSidebarContractDeliveriesNewRoute
  '/customers/$customerId': typeof AppAuthedSidebarCustomersCustomerIdRoute
  '/customers/new': typeof AppAuthedSidebarCustomersNewRoute
  '/delivery-trips/$id': typeof AppAuthedSidebarDeliveryTripsIdRoute
  '/driver/available-orders': typeof AppAuthedSidebarDriverAvailableOrdersRoute
  '/driver/cash': typeof AppAuthedSidebarDriverCashRoute
  '/logistics/shipping-carriers': typeof AppAuthedSidebarLogisticsShippingCarriersRoute
  '/orders/$orderId': typeof AppAuthedSidebarOrdersOrderIdRoute
  '/orders/new': typeof AppAuthedSidebarOrdersNewRoute
  '/orders/quick': typeof AppAuthedSidebarOrdersQuickRoute
  '/packaging-warehouse/stats': typeof AppAuthedSidebarPackagingWarehouseStatsRoute
  '/products/$productId': typeof AppAuthedSidebarProductsProductIdRoute
  '/products/new': typeof AppAuthedSidebarProductsNewRoute
  '/purchase-lots/stats': typeof AppAuthedSidebarPurchaseLotsStatsRoute
  '/scenting-warehouse/stats': typeof AppAuthedSidebarScentingWarehouseStatsRoute
  '/settings/invoice': typeof AppAuthedSidebarSettingsInvoiceRoute
  '/settings/lot-sizes': typeof AppAuthedSidebarSettingsLotSizesRoute
  '/settings/notifications': typeof AppAuthedSidebarSettingsNotificationsRoute
  '/settings/printing': typeof AppAuthedSidebarSettingsPrintingRoute
  '/settings/sidebar-layout': typeof AppAuthedSidebarSettingsSidebarLayoutRoute
  '/settings/sla': typeof AppAuthedSidebarSettingsSlaRoute
  '/settings/station-voice': typeof AppAuthedSidebarSettingsStationVoiceRoute
  '/sorting-warehouse/stats': typeof AppAuthedSidebarSortingWarehouseStatsRoute
  '/sorting-warehouse/tea-grades': typeof AppAuthedSidebarSortingWarehouseTeaGradesRoute
  '/stocktake/$id': typeof AppAuthedSidebarStocktakeIdRoute
  '/stocktake/new': typeof AppAuthedSidebarStocktakeNewRoute
  '/tea-purchases/$id': typeof AppAuthedSidebarTeaPurchasesIdRoute
  '/tea-purchases/processing': typeof AppAuthedSidebarTeaPurchasesProcessingRoute
  '/vehicles/$vehicleId': typeof AppAuthedSidebarVehiclesVehicleIdRoute
  '/warehouse-positions/$id': typeof AppAuthedSidebarWarehousePositionsIdRoute
  '/warehouse-positions/new': typeof AppAuthedSidebarWarehousePositionsNewRoute
  '/warehouse-sales/dashboard': typeof AppAuthedSidebarWarehouseSalesDashboardRoute
  '/warehouse-sales/defects': typeof AppAuthedSidebarWarehouseSalesDefectsRoute
  '/warehouse-sales/stats': typeof AppAuthedSidebarWarehouseSalesStatsRoute
  '/accounting/': typeof AppAuthedSidebarAccountingIndexRoute
  '/contract-deliveries/': typeof AppAuthedSidebarContractDeliveriesIndexRoute
  '/customers/': typeof AppAuthedSidebarCustomersIndexRoute
  '/delivery-trips/': typeof AppAuthedSidebarDeliveryTripsIndexRoute
  '/orders/': typeof AppAuthedSidebarOrdersIndexRoute
  '/packaging/': typeof AppAuthedSidebarPackagingIndexRoute
  '/products/': typeof AppAuthedSidebarProductsIndexRoute
  '/reports/': typeof AppAuthedSidebarReportsIndexRoute
  '/stocktake/': typeof AppAuthedSidebarStocktakeIndexRoute
  '/tea-purchases/': typeof AppAuthedSidebarTeaPurchasesIndexRoute
  '/users/': typeof AppAuthedSidebarUsersIndexRoute
  '/vehicles/': typeof AppAuthedSidebarVehiclesIndexRoute
  '/warehouse-positions/': typeof AppAuthedSidebarWarehousePositionsIndexRoute
  '/accounting/reports/daily': typeof AppAuthedSidebarAccountingReportsDailyRoute
  '/customers/groups/$groupId': typeof AppAuthedSidebarCustomersGroupsGroupIdRoute
  '/packaging-warehouse/lots/$id': typeof AppAuthedSidebarPackagingWarehouseLotsIdRoute
  '/packaging-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdRoute
  '/packaging-warehouse/stock-in-notes/new': typeof AppAuthedSidebarPackagingWarehouseStockInNotesNewRoute
  '/packaging-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdRoute
  '/packaging-warehouse/stock-out-notes/new': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesNewRoute
  '/packaging-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRoute
  '/packaging-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRoute
  '/purchase-lots/lots/$id': typeof AppAuthedSidebarPurchaseLotsLotsIdRoute
  '/purchase-lots/stock-in-notes/$id': typeof AppAuthedSidebarPurchaseLotsStockInNotesIdRoute
  '/purchase-lots/stock-in-notes/new': typeof AppAuthedSidebarPurchaseLotsStockInNotesNewRoute
  '/purchase-lots/stock-out-notes/$id': typeof AppAuthedSidebarPurchaseLotsStockOutNotesIdRoute
  '/purchase-lots/stock-out-notes/new': typeof AppAuthedSidebarPurchaseLotsStockOutNotesNewRoute
  '/purchase-lots/withdrawal-notes/$id': typeof AppAuthedSidebarPurchaseLotsWithdrawalNotesIdRoute
  '/purchase-lots/withdrawal-notes/new': typeof AppAuthedSidebarPurchaseLotsWithdrawalNotesNewRoute
  '/sales-warehouse/lots/$id': typeof AppAuthedSidebarSalesWarehouseLotsIdRoute
  '/sales-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarSalesWarehouseStockInNotesIdRoute
  '/sales-warehouse/stock-in-notes/new': typeof AppAuthedSidebarSalesWarehouseStockInNotesNewRoute
  '/sales-warehouse/stock-in-notes/quick': typeof AppAuthedSidebarSalesWarehouseStockInNotesQuickRoute
  '/sales-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdRoute
  '/sales-warehouse/stock-out-notes/new': typeof AppAuthedSidebarSalesWarehouseStockOutNotesNewRoute
  '/scenting-warehouse/lots/$id': typeof AppAuthedSidebarScentingWarehouseLotsIdRoute
  '/scenting-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarScentingWarehouseStockInNotesIdRoute
  '/scenting-warehouse/stock-in-notes/new': typeof AppAuthedSidebarScentingWarehouseStockInNotesNewRoute
  '/scenting-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdRoute
  '/scenting-warehouse/stock-out-notes/new': typeof AppAuthedSidebarScentingWarehouseStockOutNotesNewRoute
  '/scenting-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRoute
  '/scenting-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRoute
  '/sorting-warehouse/lots/$id': typeof AppAuthedSidebarSortingWarehouseLotsIdRoute
  '/sorting-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarSortingWarehouseStockInNotesIdRoute
  '/sorting-warehouse/stock-in-notes/new': typeof AppAuthedSidebarSortingWarehouseStockInNotesNewRoute
  '/sorting-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdRoute
  '/sorting-warehouse/stock-out-notes/new': typeof AppAuthedSidebarSortingWarehouseStockOutNotesNewRoute
  '/sorting-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRoute
  '/sorting-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRoute
  '/customers/groups/': typeof AppAuthedSidebarCustomersGroupsIndexRoute
  '/packaging-warehouse/lots/': typeof AppAuthedSidebarPackagingWarehouseLotsIndexRoute
  '/packaging-warehouse/stock-in-notes/': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIndexRoute
  '/packaging-warehouse/stock-out-notes/': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRoute
  '/packaging-warehouse/withdrawal-notes/': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRoute
  '/purchase-lots/lots/': typeof AppAuthedSidebarPurchaseLotsLotsIndexRoute
  '/purchase-lots/stock-in-notes/': typeof AppAuthedSidebarPurchaseLotsStockInNotesIndexRoute
  '/purchase-lots/stock-out-notes/': typeof AppAuthedSidebarPurchaseLotsStockOutNotesIndexRoute
  '/purchase-lots/withdrawal-notes/': typeof AppAuthedSidebarPurchaseLotsWithdrawalNotesIndexRoute
  '/sales-warehouse/lots/': typeof AppAuthedSidebarSalesWarehouseLotsIndexRoute
  '/sales-warehouse/stock-in-notes/': typeof AppAuthedSidebarSalesWarehouseStockInNotesIndexRoute
  '/sales-warehouse/stock-out-notes/': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIndexRoute
  '/scenting-warehouse/lots/': typeof AppAuthedSidebarScentingWarehouseLotsIndexRoute
  '/scenting-warehouse/stock-in-notes/': typeof AppAuthedSidebarScentingWarehouseStockInNotesIndexRoute
  '/scenting-warehouse/stock-out-notes/': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIndexRoute
  '/scenting-warehouse/withdrawal-notes/': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRoute
  '/sorting-warehouse/lots/': typeof AppAuthedSidebarSortingWarehouseLotsIndexRoute
  '/sorting-warehouse/stock-in-notes/': typeof AppAuthedSidebarSortingWarehouseStockInNotesIndexRoute
  '/sorting-warehouse/stock-out-notes/': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIndexRoute
  '/sorting-warehouse/withdrawal-notes/': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRoute
  '/packaging-warehouse/stock-in-notes/$id/edit': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRoute
  '/packaging-warehouse/stock-out-notes/$id/edit': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRoute
  '/purchase-lots/stock-in-notes/$id/edit': typeof AppAuthedSidebarPurchaseLotsStockInNotesIdEditRoute
  '/purchase-lots/stock-out-notes/$id/edit': typeof AppAuthedSidebarPurchaseLotsStockOutNotesIdEditRoute
  '/sales-warehouse/stock-in-notes/$id/edit': typeof AppAuthedSidebarSalesWarehouseStockInNotesIdEditRoute
  '/sales-warehouse/stock-out-notes/$id/edit': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRoute
  '/scenting-warehouse/stock-in-notes/$id/edit': typeof AppAuthedSidebarScentingWarehouseStockInNotesIdEditRoute
  '/scenting-warehouse/stock-out-notes/$id/edit': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRoute
  '/sorting-warehouse/stock-in-notes/$id/edit': typeof AppAuthedSidebarSortingWarehouseStockInNotesIdEditRoute
  '/sorting-warehouse/stock-out-notes/$id/edit': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof AppAuthedSidebarIndexRoute
  '/login': typeof LoginRoute
  '/trace/$code': typeof TraceCodeRoute
  '/customer-display': typeof AppAuthedCustomerDisplayRoute
  '/station': typeof AppAuthedStationRoute
  '/agriculture': typeof AppAuthedSidebarAgricultureRouteRouteWithChildren
  '/dev-playground': typeof AppAuthedSidebarDevPlaygroundRoute
  '/tracking': typeof AppAuthedSidebarTrackingRoute
  '/warehouse-stats': typeof AppAuthedSidebarWarehouseStatsRoute
  '/whats-new': typeof AppAuthedSidebarWhatsNewRoute
  '/sale/display': typeof AppAuthedSaleDisplayRoute
  '/sale': typeof AppAuthedSaleIndexRoute
  '/accounting/cash-flow': typeof AppAuthedSidebarAccountingCashFlowRoute
  '/accounting/expense-categories': typeof AppAuthedSidebarAccountingExpenseCategoriesRoute
  '/accounting/expense-sync': typeof AppAuthedSidebarAccountingExpenseSyncRoute
  '/accounting/expenses': typeof AppAuthedSidebarAccountingExpensesRoute
  '/accounting/reconciliation': typeof AppAuthedSidebarAccountingReconciliationRoute
  '/accounting/remittances': typeof AppAuthedSidebarAccountingRemittancesRoute
  '/agriculture/aroma-samplings': typeof AppAuthedSidebarAgricultureAromaSamplingsRoute
  '/agriculture/care-logs': typeof AppAuthedSidebarAgricultureCareLogsRoute
  '/agriculture/fertilizers': typeof AppAuthedSidebarAgricultureFertilizersRoute
  '/agriculture/growers': typeof AppAuthedSidebarAgricultureGrowersRoute
  '/agriculture/pesticides': typeof AppAuthedSidebarAgriculturePesticidesRoute
  '/agriculture/phases': typeof AppAuthedSidebarAgriculturePhasesRoute
  '/agriculture/product-classifications': typeof AppAuthedSidebarAgricultureProductClassificationsRoute
  '/agriculture/tea-lots': typeof AppAuthedSidebarAgricultureTeaLotsRoute
  '/agriculture/tea-packages': typeof AppAuthedSidebarAgricultureTeaPackagesRoute
  '/agriculture/tea-types': typeof AppAuthedSidebarAgricultureTeaTypesRoute
  '/agriculture/weighings': typeof AppAuthedSidebarAgricultureWeighingsRoute
  '/contract-deliveries/$id': typeof AppAuthedSidebarContractDeliveriesIdRoute
  '/contract-deliveries/new': typeof AppAuthedSidebarContractDeliveriesNewRoute
  '/customers/$customerId': typeof AppAuthedSidebarCustomersCustomerIdRoute
  '/customers/new': typeof AppAuthedSidebarCustomersNewRoute
  '/delivery-trips/$id': typeof AppAuthedSidebarDeliveryTripsIdRoute
  '/driver/available-orders': typeof AppAuthedSidebarDriverAvailableOrdersRoute
  '/driver/cash': typeof AppAuthedSidebarDriverCashRoute
  '/logistics/shipping-carriers': typeof AppAuthedSidebarLogisticsShippingCarriersRoute
  '/orders/$orderId': typeof AppAuthedSidebarOrdersOrderIdRoute
  '/orders/new': typeof AppAuthedSidebarOrdersNewRoute
  '/orders/quick': typeof AppAuthedSidebarOrdersQuickRoute
  '/packaging-warehouse/stats': typeof AppAuthedSidebarPackagingWarehouseStatsRoute
  '/products/$productId': typeof AppAuthedSidebarProductsProductIdRoute
  '/products/new': typeof AppAuthedSidebarProductsNewRoute
  '/purchase-lots/stats': typeof AppAuthedSidebarPurchaseLotsStatsRoute
  '/scenting-warehouse/stats': typeof AppAuthedSidebarScentingWarehouseStatsRoute
  '/settings/invoice': typeof AppAuthedSidebarSettingsInvoiceRoute
  '/settings/lot-sizes': typeof AppAuthedSidebarSettingsLotSizesRoute
  '/settings/notifications': typeof AppAuthedSidebarSettingsNotificationsRoute
  '/settings/printing': typeof AppAuthedSidebarSettingsPrintingRoute
  '/settings/sidebar-layout': typeof AppAuthedSidebarSettingsSidebarLayoutRoute
  '/settings/sla': typeof AppAuthedSidebarSettingsSlaRoute
  '/settings/station-voice': typeof AppAuthedSidebarSettingsStationVoiceRoute
  '/sorting-warehouse/stats': typeof AppAuthedSidebarSortingWarehouseStatsRoute
  '/sorting-warehouse/tea-grades': typeof AppAuthedSidebarSortingWarehouseTeaGradesRoute
  '/stocktake/$id': typeof AppAuthedSidebarStocktakeIdRoute
  '/stocktake/new': typeof AppAuthedSidebarStocktakeNewRoute
  '/tea-purchases/$id': typeof AppAuthedSidebarTeaPurchasesIdRoute
  '/tea-purchases/processing': typeof AppAuthedSidebarTeaPurchasesProcessingRoute
  '/vehicles/$vehicleId': typeof AppAuthedSidebarVehiclesVehicleIdRoute
  '/warehouse-positions/$id': typeof AppAuthedSidebarWarehousePositionsIdRoute
  '/warehouse-positions/new': typeof AppAuthedSidebarWarehousePositionsNewRoute
  '/warehouse-sales/dashboard': typeof AppAuthedSidebarWarehouseSalesDashboardRoute
  '/warehouse-sales/defects': typeof AppAuthedSidebarWarehouseSalesDefectsRoute
  '/warehouse-sales/stats': typeof AppAuthedSidebarWarehouseSalesStatsRoute
  '/accounting': typeof AppAuthedSidebarAccountingIndexRoute
  '/contract-deliveries': typeof AppAuthedSidebarContractDeliveriesIndexRoute
  '/customers': typeof AppAuthedSidebarCustomersIndexRoute
  '/delivery-trips': typeof AppAuthedSidebarDeliveryTripsIndexRoute
  '/orders': typeof AppAuthedSidebarOrdersIndexRoute
  '/packaging': typeof AppAuthedSidebarPackagingIndexRoute
  '/products': typeof AppAuthedSidebarProductsIndexRoute
  '/reports': typeof AppAuthedSidebarReportsIndexRoute
  '/stocktake': typeof AppAuthedSidebarStocktakeIndexRoute
  '/tea-purchases': typeof AppAuthedSidebarTeaPurchasesIndexRoute
  '/users': typeof AppAuthedSidebarUsersIndexRoute
  '/vehicles': typeof AppAuthedSidebarVehiclesIndexRoute
  '/warehouse-positions': typeof AppAuthedSidebarWarehousePositionsIndexRoute
  '/accounting/reports/daily': typeof AppAuthedSidebarAccountingReportsDailyRoute
  '/customers/groups/$groupId': typeof AppAuthedSidebarCustomersGroupsGroupIdRoute
  '/packaging-warehouse/lots/$id': typeof AppAuthedSidebarPackagingWarehouseLotsIdRoute
  '/packaging-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdRoute
  '/packaging-warehouse/stock-in-notes/new': typeof AppAuthedSidebarPackagingWarehouseStockInNotesNewRoute
  '/packaging-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdRoute
  '/packaging-warehouse/stock-out-notes/new': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesNewRoute
  '/packaging-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRoute
  '/packaging-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRoute
  '/purchase-lots/lots/$id': typeof AppAuthedSidebarPurchaseLotsLotsIdRoute
  '/purchase-lots/stock-in-notes/$id': typeof AppAuthedSidebarPurchaseLotsStockInNotesIdRoute
  '/purchase-lots/stock-in-notes/new': typeof AppAuthedSidebarPurchaseLotsStockInNotesNewRoute
  '/purchase-lots/stock-out-notes/$id': typeof AppAuthedSidebarPurchaseLotsStockOutNotesIdRoute
  '/purchase-lots/stock-out-notes/new': typeof AppAuthedSidebarPurchaseLotsStockOutNotesNewRoute
  '/purchase-lots/withdrawal-notes/$id': typeof AppAuthedSidebarPurchaseLotsWithdrawalNotesIdRoute
  '/purchase-lots/withdrawal-notes/new': typeof AppAuthedSidebarPurchaseLotsWithdrawalNotesNewRoute
  '/sales-warehouse/lots/$id': typeof AppAuthedSidebarSalesWarehouseLotsIdRoute
  '/sales-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarSalesWarehouseStockInNotesIdRoute
  '/sales-warehouse/stock-in-notes/new': typeof AppAuthedSidebarSalesWarehouseStockInNotesNewRoute
  '/sales-warehouse/stock-in-notes/quick': typeof AppAuthedSidebarSalesWarehouseStockInNotesQuickRoute
  '/sales-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdRoute
  '/sales-warehouse/stock-out-notes/new': typeof AppAuthedSidebarSalesWarehouseStockOutNotesNewRoute
  '/scenting-warehouse/lots/$id': typeof AppAuthedSidebarScentingWarehouseLotsIdRoute
  '/scenting-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarScentingWarehouseStockInNotesIdRoute
  '/scenting-warehouse/stock-in-notes/new': typeof AppAuthedSidebarScentingWarehouseStockInNotesNewRoute
  '/scenting-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdRoute
  '/scenting-warehouse/stock-out-notes/new': typeof AppAuthedSidebarScentingWarehouseStockOutNotesNewRoute
  '/scenting-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRoute
  '/scenting-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRoute
  '/sorting-warehouse/lots/$id': typeof AppAuthedSidebarSortingWarehouseLotsIdRoute
  '/sorting-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarSortingWarehouseStockInNotesIdRoute
  '/sorting-warehouse/stock-in-notes/new': typeof AppAuthedSidebarSortingWarehouseStockInNotesNewRoute
  '/sorting-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdRoute
  '/sorting-warehouse/stock-out-notes/new': typeof AppAuthedSidebarSortingWarehouseStockOutNotesNewRoute
  '/sorting-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRoute
  '/sorting-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRoute
  '/customers/groups': typeof AppAuthedSidebarCustomersGroupsIndexRoute
  '/packaging-warehouse/lots': typeof AppAuthedSidebarPackagingWarehouseLotsIndexRoute
  '/packaging-warehouse/stock-in-notes': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIndexRoute
  '/packaging-warehouse/stock-out-notes': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRoute
  '/packaging-warehouse/withdrawal-notes': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRoute
  '/purchase-lots/lots': typeof AppAuthedSidebarPurchaseLotsLotsIndexRoute
  '/purchase-lots/stock-in-notes': typeof AppAuthedSidebarPurchaseLotsStockInNotesIndexRoute
  '/purchase-lots/stock-out-notes': typeof AppAuthedSidebarPurchaseLotsStockOutNotesIndexRoute
  '/purchase-lots/withdrawal-notes': typeof AppAuthedSidebarPurchaseLotsWithdrawalNotesIndexRoute
  '/sales-warehouse/lots': typeof AppAuthedSidebarSalesWarehouseLotsIndexRoute
  '/sales-warehouse/stock-in-notes': typeof AppAuthedSidebarSalesWarehouseStockInNotesIndexRoute
  '/sales-warehouse/stock-out-notes': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIndexRoute
  '/scenting-warehouse/lots': typeof AppAuthedSidebarScentingWarehouseLotsIndexRoute
  '/scenting-warehouse/stock-in-notes': typeof AppAuthedSidebarScentingWarehouseStockInNotesIndexRoute
  '/scenting-warehouse/stock-out-notes': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIndexRoute
  '/scenting-warehouse/withdrawal-notes': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRoute
  '/sorting-warehouse/lots': typeof AppAuthedSidebarSortingWarehouseLotsIndexRoute
  '/sorting-warehouse/stock-in-notes': typeof AppAuthedSidebarSortingWarehouseStockInNotesIndexRoute
  '/sorting-warehouse/stock-out-notes': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIndexRoute
  '/sorting-warehouse/withdrawal-notes': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRoute
  '/packaging-warehouse/stock-in-notes/$id/edit': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRoute
  '/packaging-warehouse/stock-out-notes/$id/edit': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRoute
  '/purchase-lots/stock-in-notes/$id/edit': typeof AppAuthedSidebarPurchaseLotsStockInNotesIdEditRoute
  '/purchase-lots/stock-out-notes/$id/edit': typeof AppAuthedSidebarPurchaseLotsStockOutNotesIdEditRoute
  '/sales-warehouse/stock-in-notes/$id/edit': typeof AppAuthedSidebarSalesWarehouseStockInNotesIdEditRoute
  '/sales-warehouse/stock-out-notes/$id/edit': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRoute
  '/scenting-warehouse/stock-in-notes/$id/edit': typeof AppAuthedSidebarScentingWarehouseStockInNotesIdEditRoute
  '/scenting-warehouse/stock-out-notes/$id/edit': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRoute
  '/sorting-warehouse/stock-in-notes/$id/edit': typeof AppAuthedSidebarSortingWarehouseStockInNotesIdEditRoute
  '/sorting-warehouse/stock-out-notes/$id/edit': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/_authed': typeof AppAuthedRouteWithChildren
  '/trace/$code': typeof TraceCodeRoute
  '/_app/_authed/_sidebar': typeof AppAuthedSidebarRouteWithChildren
  '/_app/_authed/customer-display': typeof AppAuthedCustomerDisplayRoute
  '/_app/_authed/sale': typeof AppAuthedSaleRouteWithChildren
  '/_app/_authed/station': typeof AppAuthedStationRoute
  '/_app/_authed/_sidebar/agriculture': typeof AppAuthedSidebarAgricultureRouteRouteWithChildren
  '/_app/_authed/_sidebar/dev-playground': typeof AppAuthedSidebarDevPlaygroundRoute
  '/_app/_authed/_sidebar/tracking': typeof AppAuthedSidebarTrackingRoute
  '/_app/_authed/_sidebar/warehouse-stats': typeof AppAuthedSidebarWarehouseStatsRoute
  '/_app/_authed/_sidebar/whats-new': typeof AppAuthedSidebarWhatsNewRoute
  '/_app/_authed/sale/display': typeof AppAuthedSaleDisplayRoute
  '/_app/_authed/_sidebar/': typeof AppAuthedSidebarIndexRoute
  '/_app/_authed/sale/': typeof AppAuthedSaleIndexRoute
  '/_app/_authed/_sidebar/accounting/cash-flow': typeof AppAuthedSidebarAccountingCashFlowRoute
  '/_app/_authed/_sidebar/accounting/expense-categories': typeof AppAuthedSidebarAccountingExpenseCategoriesRoute
  '/_app/_authed/_sidebar/accounting/expense-sync': typeof AppAuthedSidebarAccountingExpenseSyncRoute
  '/_app/_authed/_sidebar/accounting/expenses': typeof AppAuthedSidebarAccountingExpensesRoute
  '/_app/_authed/_sidebar/accounting/reconciliation': typeof AppAuthedSidebarAccountingReconciliationRoute
  '/_app/_authed/_sidebar/accounting/remittances': typeof AppAuthedSidebarAccountingRemittancesRoute
  '/_app/_authed/_sidebar/agriculture/aroma-samplings': typeof AppAuthedSidebarAgricultureAromaSamplingsRoute
  '/_app/_authed/_sidebar/agriculture/care-logs': typeof AppAuthedSidebarAgricultureCareLogsRoute
  '/_app/_authed/_sidebar/agriculture/fertilizers': typeof AppAuthedSidebarAgricultureFertilizersRoute
  '/_app/_authed/_sidebar/agriculture/growers': typeof AppAuthedSidebarAgricultureGrowersRoute
  '/_app/_authed/_sidebar/agriculture/pesticides': typeof AppAuthedSidebarAgriculturePesticidesRoute
  '/_app/_authed/_sidebar/agriculture/phases': typeof AppAuthedSidebarAgriculturePhasesRoute
  '/_app/_authed/_sidebar/agriculture/product-classifications': typeof AppAuthedSidebarAgricultureProductClassificationsRoute
  '/_app/_authed/_sidebar/agriculture/tea-lots': typeof AppAuthedSidebarAgricultureTeaLotsRoute
  '/_app/_authed/_sidebar/agriculture/tea-packages': typeof AppAuthedSidebarAgricultureTeaPackagesRoute
  '/_app/_authed/_sidebar/agriculture/tea-types': typeof AppAuthedSidebarAgricultureTeaTypesRoute
  '/_app/_authed/_sidebar/agriculture/weighings': typeof AppAuthedSidebarAgricultureWeighingsRoute
  '/_app/_authed/_sidebar/contract-deliveries/$id': typeof AppAuthedSidebarContractDeliveriesIdRoute
  '/_app/_authed/_sidebar/contract-deliveries/new': typeof AppAuthedSidebarContractDeliveriesNewRoute
  '/_app/_authed/_sidebar/customers/$customerId': typeof AppAuthedSidebarCustomersCustomerIdRoute
  '/_app/_authed/_sidebar/customers/new': typeof AppAuthedSidebarCustomersNewRoute
  '/_app/_authed/_sidebar/delivery-trips/$id': typeof AppAuthedSidebarDeliveryTripsIdRoute
  '/_app/_authed/_sidebar/driver/available-orders': typeof AppAuthedSidebarDriverAvailableOrdersRoute
  '/_app/_authed/_sidebar/driver/cash': typeof AppAuthedSidebarDriverCashRoute
  '/_app/_authed/_sidebar/logistics/shipping-carriers': typeof AppAuthedSidebarLogisticsShippingCarriersRoute
  '/_app/_authed/_sidebar/orders/$orderId': typeof AppAuthedSidebarOrdersOrderIdRoute
  '/_app/_authed/_sidebar/orders/new': typeof AppAuthedSidebarOrdersNewRoute
  '/_app/_authed/_sidebar/orders/quick': typeof AppAuthedSidebarOrdersQuickRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stats': typeof AppAuthedSidebarPackagingWarehouseStatsRoute
  '/_app/_authed/_sidebar/products/$productId': typeof AppAuthedSidebarProductsProductIdRoute
  '/_app/_authed/_sidebar/products/new': typeof AppAuthedSidebarProductsNewRoute
  '/_app/_authed/_sidebar/purchase-lots/stats': typeof AppAuthedSidebarPurchaseLotsStatsRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stats': typeof AppAuthedSidebarScentingWarehouseStatsRoute
  '/_app/_authed/_sidebar/settings/invoice': typeof AppAuthedSidebarSettingsInvoiceRoute
  '/_app/_authed/_sidebar/settings/lot-sizes': typeof AppAuthedSidebarSettingsLotSizesRoute
  '/_app/_authed/_sidebar/settings/notifications': typeof AppAuthedSidebarSettingsNotificationsRoute
  '/_app/_authed/_sidebar/settings/printing': typeof AppAuthedSidebarSettingsPrintingRoute
  '/_app/_authed/_sidebar/settings/sidebar-layout': typeof AppAuthedSidebarSettingsSidebarLayoutRoute
  '/_app/_authed/_sidebar/settings/sla': typeof AppAuthedSidebarSettingsSlaRoute
  '/_app/_authed/_sidebar/settings/station-voice': typeof AppAuthedSidebarSettingsStationVoiceRoute
  '/_app/_authed/_sidebar/sorting-warehouse/stats': typeof AppAuthedSidebarSortingWarehouseStatsRoute
  '/_app/_authed/_sidebar/sorting-warehouse/tea-grades': typeof AppAuthedSidebarSortingWarehouseTeaGradesRoute
  '/_app/_authed/_sidebar/stocktake/$id': typeof AppAuthedSidebarStocktakeIdRoute
  '/_app/_authed/_sidebar/stocktake/new': typeof AppAuthedSidebarStocktakeNewRoute
  '/_app/_authed/_sidebar/tea-purchases/$id': typeof AppAuthedSidebarTeaPurchasesIdRoute
  '/_app/_authed/_sidebar/tea-purchases/processing': typeof AppAuthedSidebarTeaPurchasesProcessingRoute
  '/_app/_authed/_sidebar/vehicles/$vehicleId': typeof AppAuthedSidebarVehiclesVehicleIdRoute
  '/_app/_authed/_sidebar/warehouse-positions/$id': typeof AppAuthedSidebarWarehousePositionsIdRoute
  '/_app/_authed/_sidebar/warehouse-positions/new': typeof AppAuthedSidebarWarehousePositionsNewRoute
  '/_app/_authed/_sidebar/warehouse-sales/dashboard': typeof AppAuthedSidebarWarehouseSalesDashboardRoute
  '/_app/_authed/_sidebar/warehouse-sales/defects': typeof AppAuthedSidebarWarehouseSalesDefectsRoute
  '/_app/_authed/_sidebar/warehouse-sales/stats': typeof AppAuthedSidebarWarehouseSalesStatsRoute
  '/_app/_authed/_sidebar/accounting/': typeof AppAuthedSidebarAccountingIndexRoute
  '/_app/_authed/_sidebar/contract-deliveries/': typeof AppAuthedSidebarContractDeliveriesIndexRoute
  '/_app/_authed/_sidebar/customers/': typeof AppAuthedSidebarCustomersIndexRoute
  '/_app/_authed/_sidebar/delivery-trips/': typeof AppAuthedSidebarDeliveryTripsIndexRoute
  '/_app/_authed/_sidebar/orders/': typeof AppAuthedSidebarOrdersIndexRoute
  '/_app/_authed/_sidebar/packaging/': typeof AppAuthedSidebarPackagingIndexRoute
  '/_app/_authed/_sidebar/products/': typeof AppAuthedSidebarProductsIndexRoute
  '/_app/_authed/_sidebar/reports/': typeof AppAuthedSidebarReportsIndexRoute
  '/_app/_authed/_sidebar/stocktake/': typeof AppAuthedSidebarStocktakeIndexRoute
  '/_app/_authed/_sidebar/tea-purchases/': typeof AppAuthedSidebarTeaPurchasesIndexRoute
  '/_app/_authed/_sidebar/users/': typeof AppAuthedSidebarUsersIndexRoute
  '/_app/_authed/_sidebar/vehicles/': typeof AppAuthedSidebarVehiclesIndexRoute
  '/_app/_authed/_sidebar/warehouse-positions/': typeof AppAuthedSidebarWarehousePositionsIndexRoute
  '/_app/_authed/_sidebar/accounting/reports/daily': typeof AppAuthedSidebarAccountingReportsDailyRoute
  '/_app/_authed/_sidebar/customers/groups/$groupId': typeof AppAuthedSidebarCustomersGroupsGroupIdRoute
  '/_app/_authed/_sidebar/packaging-warehouse/lots/$id': typeof AppAuthedSidebarPackagingWarehouseLotsIdRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/new': typeof AppAuthedSidebarPackagingWarehouseStockInNotesNewRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/new': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesNewRoute
  '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRoute
  '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRoute
  '/_app/_authed/_sidebar/purchase-lots/lots/$id': typeof AppAuthedSidebarPurchaseLotsLotsIdRoute
  '/_app/_authed/_sidebar/purchase-lots/stock-in-notes/$id': typeof AppAuthedSidebarPurchaseLotsStockInNotesIdRoute
  '/_app/_authed/_sidebar/purchase-lots/stock-in-notes/new': typeof AppAuthedSidebarPurchaseLotsStockInNotesNewRoute
  '/_app/_authed/_sidebar/purchase-lots/stock-out-notes/$id': typeof AppAuthedSidebarPurchaseLotsStockOutNotesIdRoute
  '/_app/_authed/_sidebar/purchase-lots/stock-out-notes/new': typeof AppAuthedSidebarPurchaseLotsStockOutNotesNewRoute
  '/_app/_authed/_sidebar/purchase-lots/withdrawal-notes/$id': typeof AppAuthedSidebarPurchaseLotsWithdrawalNotesIdRoute
  '/_app/_authed/_sidebar/purchase-lots/withdrawal-notes/new': typeof AppAuthedSidebarPurchaseLotsWithdrawalNotesNewRoute
  '/_app/_authed/_sidebar/sales-warehouse/lots/$id': typeof AppAuthedSidebarSalesWarehouseLotsIdRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarSalesWarehouseStockInNotesIdRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/new': typeof AppAuthedSidebarSalesWarehouseStockInNotesNewRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/quick': typeof AppAuthedSidebarSalesWarehouseStockInNotesQuickRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/new': typeof AppAuthedSidebarSalesWarehouseStockOutNotesNewRoute
  '/_app/_authed/_sidebar/scenting-warehouse/lots/$id': typeof AppAuthedSidebarScentingWarehouseLotsIdRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarScentingWarehouseStockInNotesIdRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/new': typeof AppAuthedSidebarScentingWarehouseStockInNotesNewRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/new': typeof AppAuthedSidebarScentingWarehouseStockOutNotesNewRoute
  '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRoute
  '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRoute
  '/_app/_authed/_sidebar/sorting-warehouse/lots/$id': typeof AppAuthedSidebarSortingWarehouseLotsIdRoute
  '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id': typeof AppAuthedSidebarSortingWarehouseStockInNotesIdRoute
  '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/new': typeof AppAuthedSidebarSortingWarehouseStockInNotesNewRoute
  '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdRoute
  '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/new': typeof AppAuthedSidebarSortingWarehouseStockOutNotesNewRoute
  '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/$id': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRoute
  '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/new': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRoute
  '/_app/_authed/_sidebar/customers/groups/': typeof AppAuthedSidebarCustomersGroupsIndexRoute
  '/_app/_authed/_sidebar/packaging-warehouse/lots/': typeof AppAuthedSidebarPackagingWarehouseLotsIndexRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIndexRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRoute
  '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/': typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRoute
  '/_app/_authed/_sidebar/purchase-lots/lots/': typeof AppAuthedSidebarPurchaseLotsLotsIndexRoute
  '/_app/_authed/_sidebar/purchase-lots/stock-in-notes/': typeof AppAuthedSidebarPurchaseLotsStockInNotesIndexRoute
  '/_app/_authed/_sidebar/purchase-lots/stock-out-notes/': typeof AppAuthedSidebarPurchaseLotsStockOutNotesIndexRoute
  '/_app/_authed/_sidebar/purchase-lots/withdrawal-notes/': typeof AppAuthedSidebarPurchaseLotsWithdrawalNotesIndexRoute
  '/_app/_authed/_sidebar/sales-warehouse/lots/': typeof AppAuthedSidebarSalesWarehouseLotsIndexRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/': typeof AppAuthedSidebarSalesWarehouseStockInNotesIndexRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIndexRoute
  '/_app/_authed/_sidebar/scenting-warehouse/lots/': typeof AppAuthedSidebarScentingWarehouseLotsIndexRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/': typeof AppAuthedSidebarScentingWarehouseStockInNotesIndexRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIndexRoute
  '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/': typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRoute
  '/_app/_authed/_sidebar/sorting-warehouse/lots/': typeof AppAuthedSidebarSortingWarehouseLotsIndexRoute
  '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/': typeof AppAuthedSidebarSortingWarehouseStockInNotesIndexRoute
  '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIndexRoute
  '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/': typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id_/edit': typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRoute
  '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id_/edit': typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRoute
  '/_app/_authed/_sidebar/purchase-lots/stock-in-notes/$id_/edit': typeof AppAuthedSidebarPurchaseLotsStockInNotesIdEditRoute
  '/_app/_authed/_sidebar/purchase-lots/stock-out-notes/$id_/edit': typeof AppAuthedSidebarPurchaseLotsStockOutNotesIdEditRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id_/edit': typeof AppAuthedSidebarSalesWarehouseStockInNotesIdEditRoute
  '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id_/edit': typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id_/edit': typeof AppAuthedSidebarScentingWarehouseStockInNotesIdEditRoute
  '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id_/edit': typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRoute
  '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id_/edit': typeof AppAuthedSidebarSortingWarehouseStockInNotesIdEditRoute
  '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id_/edit': typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/trace/$code'
    | '/customer-display'
    | '/sale'
    | '/station'
    | '/agriculture'
    | '/dev-playground'
    | '/tracking'
    | '/warehouse-stats'
    | '/whats-new'
    | '/sale/display'
    | '/sale/'
    | '/accounting/cash-flow'
    | '/accounting/expense-categories'
    | '/accounting/expense-sync'
    | '/accounting/expenses'
    | '/accounting/reconciliation'
    | '/accounting/remittances'
    | '/agriculture/aroma-samplings'
    | '/agriculture/care-logs'
    | '/agriculture/fertilizers'
    | '/agriculture/growers'
    | '/agriculture/pesticides'
    | '/agriculture/phases'
    | '/agriculture/product-classifications'
    | '/agriculture/tea-lots'
    | '/agriculture/tea-packages'
    | '/agriculture/tea-types'
    | '/agriculture/weighings'
    | '/contract-deliveries/$id'
    | '/contract-deliveries/new'
    | '/customers/$customerId'
    | '/customers/new'
    | '/delivery-trips/$id'
    | '/driver/available-orders'
    | '/driver/cash'
    | '/logistics/shipping-carriers'
    | '/orders/$orderId'
    | '/orders/new'
    | '/orders/quick'
    | '/packaging-warehouse/stats'
    | '/products/$productId'
    | '/products/new'
    | '/purchase-lots/stats'
    | '/scenting-warehouse/stats'
    | '/settings/invoice'
    | '/settings/lot-sizes'
    | '/settings/notifications'
    | '/settings/printing'
    | '/settings/sidebar-layout'
    | '/settings/sla'
    | '/settings/station-voice'
    | '/sorting-warehouse/stats'
    | '/sorting-warehouse/tea-grades'
    | '/stocktake/$id'
    | '/stocktake/new'
    | '/tea-purchases/$id'
    | '/tea-purchases/processing'
    | '/vehicles/$vehicleId'
    | '/warehouse-positions/$id'
    | '/warehouse-positions/new'
    | '/warehouse-sales/dashboard'
    | '/warehouse-sales/defects'
    | '/warehouse-sales/stats'
    | '/accounting/'
    | '/contract-deliveries/'
    | '/customers/'
    | '/delivery-trips/'
    | '/orders/'
    | '/packaging/'
    | '/products/'
    | '/reports/'
    | '/stocktake/'
    | '/tea-purchases/'
    | '/users/'
    | '/vehicles/'
    | '/warehouse-positions/'
    | '/accounting/reports/daily'
    | '/customers/groups/$groupId'
    | '/packaging-warehouse/lots/$id'
    | '/packaging-warehouse/stock-in-notes/$id'
    | '/packaging-warehouse/stock-in-notes/new'
    | '/packaging-warehouse/stock-out-notes/$id'
    | '/packaging-warehouse/stock-out-notes/new'
    | '/packaging-warehouse/withdrawal-notes/$id'
    | '/packaging-warehouse/withdrawal-notes/new'
    | '/purchase-lots/lots/$id'
    | '/purchase-lots/stock-in-notes/$id'
    | '/purchase-lots/stock-in-notes/new'
    | '/purchase-lots/stock-out-notes/$id'
    | '/purchase-lots/stock-out-notes/new'
    | '/purchase-lots/withdrawal-notes/$id'
    | '/purchase-lots/withdrawal-notes/new'
    | '/sales-warehouse/lots/$id'
    | '/sales-warehouse/stock-in-notes/$id'
    | '/sales-warehouse/stock-in-notes/new'
    | '/sales-warehouse/stock-in-notes/quick'
    | '/sales-warehouse/stock-out-notes/$id'
    | '/sales-warehouse/stock-out-notes/new'
    | '/scenting-warehouse/lots/$id'
    | '/scenting-warehouse/stock-in-notes/$id'
    | '/scenting-warehouse/stock-in-notes/new'
    | '/scenting-warehouse/stock-out-notes/$id'
    | '/scenting-warehouse/stock-out-notes/new'
    | '/scenting-warehouse/withdrawal-notes/$id'
    | '/scenting-warehouse/withdrawal-notes/new'
    | '/sorting-warehouse/lots/$id'
    | '/sorting-warehouse/stock-in-notes/$id'
    | '/sorting-warehouse/stock-in-notes/new'
    | '/sorting-warehouse/stock-out-notes/$id'
    | '/sorting-warehouse/stock-out-notes/new'
    | '/sorting-warehouse/withdrawal-notes/$id'
    | '/sorting-warehouse/withdrawal-notes/new'
    | '/customers/groups/'
    | '/packaging-warehouse/lots/'
    | '/packaging-warehouse/stock-in-notes/'
    | '/packaging-warehouse/stock-out-notes/'
    | '/packaging-warehouse/withdrawal-notes/'
    | '/purchase-lots/lots/'
    | '/purchase-lots/stock-in-notes/'
    | '/purchase-lots/stock-out-notes/'
    | '/purchase-lots/withdrawal-notes/'
    | '/sales-warehouse/lots/'
    | '/sales-warehouse/stock-in-notes/'
    | '/sales-warehouse/stock-out-notes/'
    | '/scenting-warehouse/lots/'
    | '/scenting-warehouse/stock-in-notes/'
    | '/scenting-warehouse/stock-out-notes/'
    | '/scenting-warehouse/withdrawal-notes/'
    | '/sorting-warehouse/lots/'
    | '/sorting-warehouse/stock-in-notes/'
    | '/sorting-warehouse/stock-out-notes/'
    | '/sorting-warehouse/withdrawal-notes/'
    | '/packaging-warehouse/stock-in-notes/$id/edit'
    | '/packaging-warehouse/stock-out-notes/$id/edit'
    | '/purchase-lots/stock-in-notes/$id/edit'
    | '/purchase-lots/stock-out-notes/$id/edit'
    | '/sales-warehouse/stock-in-notes/$id/edit'
    | '/sales-warehouse/stock-out-notes/$id/edit'
    | '/scenting-warehouse/stock-in-notes/$id/edit'
    | '/scenting-warehouse/stock-out-notes/$id/edit'
    | '/sorting-warehouse/stock-in-notes/$id/edit'
    | '/sorting-warehouse/stock-out-notes/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/trace/$code'
    | '/customer-display'
    | '/station'
    | '/agriculture'
    | '/dev-playground'
    | '/tracking'
    | '/warehouse-stats'
    | '/whats-new'
    | '/sale/display'
    | '/sale'
    | '/accounting/cash-flow'
    | '/accounting/expense-categories'
    | '/accounting/expense-sync'
    | '/accounting/expenses'
    | '/accounting/reconciliation'
    | '/accounting/remittances'
    | '/agriculture/aroma-samplings'
    | '/agriculture/care-logs'
    | '/agriculture/fertilizers'
    | '/agriculture/growers'
    | '/agriculture/pesticides'
    | '/agriculture/phases'
    | '/agriculture/product-classifications'
    | '/agriculture/tea-lots'
    | '/agriculture/tea-packages'
    | '/agriculture/tea-types'
    | '/agriculture/weighings'
    | '/contract-deliveries/$id'
    | '/contract-deliveries/new'
    | '/customers/$customerId'
    | '/customers/new'
    | '/delivery-trips/$id'
    | '/driver/available-orders'
    | '/driver/cash'
    | '/logistics/shipping-carriers'
    | '/orders/$orderId'
    | '/orders/new'
    | '/orders/quick'
    | '/packaging-warehouse/stats'
    | '/products/$productId'
    | '/products/new'
    | '/purchase-lots/stats'
    | '/scenting-warehouse/stats'
    | '/settings/invoice'
    | '/settings/lot-sizes'
    | '/settings/notifications'
    | '/settings/printing'
    | '/settings/sidebar-layout'
    | '/settings/sla'
    | '/settings/station-voice'
    | '/sorting-warehouse/stats'
    | '/sorting-warehouse/tea-grades'
    | '/stocktake/$id'
    | '/stocktake/new'
    | '/tea-purchases/$id'
    | '/tea-purchases/processing'
    | '/vehicles/$vehicleId'
    | '/warehouse-positions/$id'
    | '/warehouse-positions/new'
    | '/warehouse-sales/dashboard'
    | '/warehouse-sales/defects'
    | '/warehouse-sales/stats'
    | '/accounting'
    | '/contract-deliveries'
    | '/customers'
    | '/delivery-trips'
    | '/orders'
    | '/packaging'
    | '/products'
    | '/reports'
    | '/stocktake'
    | '/tea-purchases'
    | '/users'
    | '/vehicles'
    | '/warehouse-positions'
    | '/accounting/reports/daily'
    | '/customers/groups/$groupId'
    | '/packaging-warehouse/lots/$id'
    | '/packaging-warehouse/stock-in-notes/$id'
    | '/packaging-warehouse/stock-in-notes/new'
    | '/packaging-warehouse/stock-out-notes/$id'
    | '/packaging-warehouse/stock-out-notes/new'
    | '/packaging-warehouse/withdrawal-notes/$id'
    | '/packaging-warehouse/withdrawal-notes/new'
    | '/purchase-lots/lots/$id'
    | '/purchase-lots/stock-in-notes/$id'
    | '/purchase-lots/stock-in-notes/new'
    | '/purchase-lots/stock-out-notes/$id'
    | '/purchase-lots/stock-out-notes/new'
    | '/purchase-lots/withdrawal-notes/$id'
    | '/purchase-lots/withdrawal-notes/new'
    | '/sales-warehouse/lots/$id'
    | '/sales-warehouse/stock-in-notes/$id'
    | '/sales-warehouse/stock-in-notes/new'
    | '/sales-warehouse/stock-in-notes/quick'
    | '/sales-warehouse/stock-out-notes/$id'
    | '/sales-warehouse/stock-out-notes/new'
    | '/scenting-warehouse/lots/$id'
    | '/scenting-warehouse/stock-in-notes/$id'
    | '/scenting-warehouse/stock-in-notes/new'
    | '/scenting-warehouse/stock-out-notes/$id'
    | '/scenting-warehouse/stock-out-notes/new'
    | '/scenting-warehouse/withdrawal-notes/$id'
    | '/scenting-warehouse/withdrawal-notes/new'
    | '/sorting-warehouse/lots/$id'
    | '/sorting-warehouse/stock-in-notes/$id'
    | '/sorting-warehouse/stock-in-notes/new'
    | '/sorting-warehouse/stock-out-notes/$id'
    | '/sorting-warehouse/stock-out-notes/new'
    | '/sorting-warehouse/withdrawal-notes/$id'
    | '/sorting-warehouse/withdrawal-notes/new'
    | '/customers/groups'
    | '/packaging-warehouse/lots'
    | '/packaging-warehouse/stock-in-notes'
    | '/packaging-warehouse/stock-out-notes'
    | '/packaging-warehouse/withdrawal-notes'
    | '/purchase-lots/lots'
    | '/purchase-lots/stock-in-notes'
    | '/purchase-lots/stock-out-notes'
    | '/purchase-lots/withdrawal-notes'
    | '/sales-warehouse/lots'
    | '/sales-warehouse/stock-in-notes'
    | '/sales-warehouse/stock-out-notes'
    | '/scenting-warehouse/lots'
    | '/scenting-warehouse/stock-in-notes'
    | '/scenting-warehouse/stock-out-notes'
    | '/scenting-warehouse/withdrawal-notes'
    | '/sorting-warehouse/lots'
    | '/sorting-warehouse/stock-in-notes'
    | '/sorting-warehouse/stock-out-notes'
    | '/sorting-warehouse/withdrawal-notes'
    | '/packaging-warehouse/stock-in-notes/$id/edit'
    | '/packaging-warehouse/stock-out-notes/$id/edit'
    | '/purchase-lots/stock-in-notes/$id/edit'
    | '/purchase-lots/stock-out-notes/$id/edit'
    | '/sales-warehouse/stock-in-notes/$id/edit'
    | '/sales-warehouse/stock-out-notes/$id/edit'
    | '/scenting-warehouse/stock-in-notes/$id/edit'
    | '/scenting-warehouse/stock-out-notes/$id/edit'
    | '/sorting-warehouse/stock-in-notes/$id/edit'
    | '/sorting-warehouse/stock-out-notes/$id/edit'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/_authed'
    | '/trace/$code'
    | '/_app/_authed/_sidebar'
    | '/_app/_authed/customer-display'
    | '/_app/_authed/sale'
    | '/_app/_authed/station'
    | '/_app/_authed/_sidebar/agriculture'
    | '/_app/_authed/_sidebar/dev-playground'
    | '/_app/_authed/_sidebar/tracking'
    | '/_app/_authed/_sidebar/warehouse-stats'
    | '/_app/_authed/_sidebar/whats-new'
    | '/_app/_authed/sale/display'
    | '/_app/_authed/_sidebar/'
    | '/_app/_authed/sale/'
    | '/_app/_authed/_sidebar/accounting/cash-flow'
    | '/_app/_authed/_sidebar/accounting/expense-categories'
    | '/_app/_authed/_sidebar/accounting/expense-sync'
    | '/_app/_authed/_sidebar/accounting/expenses'
    | '/_app/_authed/_sidebar/accounting/reconciliation'
    | '/_app/_authed/_sidebar/accounting/remittances'
    | '/_app/_authed/_sidebar/agriculture/aroma-samplings'
    | '/_app/_authed/_sidebar/agriculture/care-logs'
    | '/_app/_authed/_sidebar/agriculture/fertilizers'
    | '/_app/_authed/_sidebar/agriculture/growers'
    | '/_app/_authed/_sidebar/agriculture/pesticides'
    | '/_app/_authed/_sidebar/agriculture/phases'
    | '/_app/_authed/_sidebar/agriculture/product-classifications'
    | '/_app/_authed/_sidebar/agriculture/tea-lots'
    | '/_app/_authed/_sidebar/agriculture/tea-packages'
    | '/_app/_authed/_sidebar/agriculture/tea-types'
    | '/_app/_authed/_sidebar/agriculture/weighings'
    | '/_app/_authed/_sidebar/contract-deliveries/$id'
    | '/_app/_authed/_sidebar/contract-deliveries/new'
    | '/_app/_authed/_sidebar/customers/$customerId'
    | '/_app/_authed/_sidebar/customers/new'
    | '/_app/_authed/_sidebar/delivery-trips/$id'
    | '/_app/_authed/_sidebar/driver/available-orders'
    | '/_app/_authed/_sidebar/driver/cash'
    | '/_app/_authed/_sidebar/logistics/shipping-carriers'
    | '/_app/_authed/_sidebar/orders/$orderId'
    | '/_app/_authed/_sidebar/orders/new'
    | '/_app/_authed/_sidebar/orders/quick'
    | '/_app/_authed/_sidebar/packaging-warehouse/stats'
    | '/_app/_authed/_sidebar/products/$productId'
    | '/_app/_authed/_sidebar/products/new'
    | '/_app/_authed/_sidebar/purchase-lots/stats'
    | '/_app/_authed/_sidebar/scenting-warehouse/stats'
    | '/_app/_authed/_sidebar/settings/invoice'
    | '/_app/_authed/_sidebar/settings/lot-sizes'
    | '/_app/_authed/_sidebar/settings/notifications'
    | '/_app/_authed/_sidebar/settings/printing'
    | '/_app/_authed/_sidebar/settings/sidebar-layout'
    | '/_app/_authed/_sidebar/settings/sla'
    | '/_app/_authed/_sidebar/settings/station-voice'
    | '/_app/_authed/_sidebar/sorting-warehouse/stats'
    | '/_app/_authed/_sidebar/sorting-warehouse/tea-grades'
    | '/_app/_authed/_sidebar/stocktake/$id'
    | '/_app/_authed/_sidebar/stocktake/new'
    | '/_app/_authed/_sidebar/tea-purchases/$id'
    | '/_app/_authed/_sidebar/tea-purchases/processing'
    | '/_app/_authed/_sidebar/vehicles/$vehicleId'
    | '/_app/_authed/_sidebar/warehouse-positions/$id'
    | '/_app/_authed/_sidebar/warehouse-positions/new'
    | '/_app/_authed/_sidebar/warehouse-sales/dashboard'
    | '/_app/_authed/_sidebar/warehouse-sales/defects'
    | '/_app/_authed/_sidebar/warehouse-sales/stats'
    | '/_app/_authed/_sidebar/accounting/'
    | '/_app/_authed/_sidebar/contract-deliveries/'
    | '/_app/_authed/_sidebar/customers/'
    | '/_app/_authed/_sidebar/delivery-trips/'
    | '/_app/_authed/_sidebar/orders/'
    | '/_app/_authed/_sidebar/packaging/'
    | '/_app/_authed/_sidebar/products/'
    | '/_app/_authed/_sidebar/reports/'
    | '/_app/_authed/_sidebar/stocktake/'
    | '/_app/_authed/_sidebar/tea-purchases/'
    | '/_app/_authed/_sidebar/users/'
    | '/_app/_authed/_sidebar/vehicles/'
    | '/_app/_authed/_sidebar/warehouse-positions/'
    | '/_app/_authed/_sidebar/accounting/reports/daily'
    | '/_app/_authed/_sidebar/customers/groups/$groupId'
    | '/_app/_authed/_sidebar/packaging-warehouse/lots/$id'
    | '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id'
    | '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/new'
    | '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id'
    | '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/new'
    | '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/$id'
    | '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/new'
    | '/_app/_authed/_sidebar/purchase-lots/lots/$id'
    | '/_app/_authed/_sidebar/purchase-lots/stock-in-notes/$id'
    | '/_app/_authed/_sidebar/purchase-lots/stock-in-notes/new'
    | '/_app/_authed/_sidebar/purchase-lots/stock-out-notes/$id'
    | '/_app/_authed/_sidebar/purchase-lots/stock-out-notes/new'
    | '/_app/_authed/_sidebar/purchase-lots/withdrawal-notes/$id'
    | '/_app/_authed/_sidebar/purchase-lots/withdrawal-notes/new'
    | '/_app/_authed/_sidebar/sales-warehouse/lots/$id'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/new'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/quick'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/new'
    | '/_app/_authed/_sidebar/scenting-warehouse/lots/$id'
    | '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id'
    | '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/new'
    | '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id'
    | '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/new'
    | '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/$id'
    | '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/new'
    | '/_app/_authed/_sidebar/sorting-warehouse/lots/$id'
    | '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id'
    | '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/new'
    | '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id'
    | '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/new'
    | '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/$id'
    | '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/new'
    | '/_app/_authed/_sidebar/customers/groups/'
    | '/_app/_authed/_sidebar/packaging-warehouse/lots/'
    | '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/'
    | '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/'
    | '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/'
    | '/_app/_authed/_sidebar/purchase-lots/lots/'
    | '/_app/_authed/_sidebar/purchase-lots/stock-in-notes/'
    | '/_app/_authed/_sidebar/purchase-lots/stock-out-notes/'
    | '/_app/_authed/_sidebar/purchase-lots/withdrawal-notes/'
    | '/_app/_authed/_sidebar/sales-warehouse/lots/'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/'
    | '/_app/_authed/_sidebar/scenting-warehouse/lots/'
    | '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/'
    | '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/'
    | '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/'
    | '/_app/_authed/_sidebar/sorting-warehouse/lots/'
    | '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/'
    | '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/'
    | '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/'
    | '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id_/edit'
    | '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id_/edit'
    | '/_app/_authed/_sidebar/purchase-lots/stock-in-notes/$id_/edit'
    | '/_app/_authed/_sidebar/purchase-lots/stock-out-notes/$id_/edit'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id_/edit'
    | '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id_/edit'
    | '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id_/edit'
    | '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id_/edit'
    | '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id_/edit'
    | '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id_/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  TraceCodeRoute: typeof TraceCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trace/$code': {
      id: '/trace/$code'
      path: '/trace/$code'
      fullPath: '/trace/$code'
      preLoaderRoute: typeof TraceCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_authed': {
      id: '/_app/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppAuthedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_authed/station': {
      id: '/_app/_authed/station'
      path: '/station'
      fullPath: '/station'
      preLoaderRoute: typeof AppAuthedStationRouteImport
      parentRoute: typeof AppAuthedRoute
    }
    '/_app/_authed/sale': {
      id: '/_app/_authed/sale'
      path: '/sale'
      fullPath: '/sale'
      preLoaderRoute: typeof AppAuthedSaleRouteImport
      parentRoute: typeof AppAuthedRoute
    }
    '/_app/_authed/customer-display': {
      id: '/_app/_authed/customer-display'
      path: '/customer-display'
      fullPath: '/customer-display'
      preLoaderRoute: typeof AppAuthedCustomerDisplayRouteImport
      parentRoute: typeof AppAuthedRoute
    }
    '/_app/_authed/_sidebar': {
      id: '/_app/_authed/_sidebar'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppAuthedSidebarRouteImport
      parentRoute: typeof AppAuthedRoute
    }
    '/_app/_authed/sale/': {
      id: '/_app/_authed/sale/'
      path: '/'
      fullPath: '/sale/'
      preLoaderRoute: typeof AppAuthedSaleIndexRouteImport
      parentRoute: typeof AppAuthedSaleRoute
    }
    '/_app/_authed/_sidebar/': {
      id: '/_app/_authed/_sidebar/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppAuthedSidebarIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/sale/display': {
      id: '/_app/_authed/sale/display'
      path: '/display'
      fullPath: '/sale/display'
      preLoaderRoute: typeof AppAuthedSaleDisplayRouteImport
      parentRoute: typeof AppAuthedSaleRoute
    }
    '/_app/_authed/_sidebar/whats-new': {
      id: '/_app/_authed/_sidebar/whats-new'
      path: '/whats-new'
      fullPath: '/whats-new'
      preLoaderRoute: typeof AppAuthedSidebarWhatsNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/warehouse-stats': {
      id: '/_app/_authed/_sidebar/warehouse-stats'
      path: '/warehouse-stats'
      fullPath: '/warehouse-stats'
      preLoaderRoute: typeof AppAuthedSidebarWarehouseStatsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/tracking': {
      id: '/_app/_authed/_sidebar/tracking'
      path: '/tracking'
      fullPath: '/tracking'
      preLoaderRoute: typeof AppAuthedSidebarTrackingRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/dev-playground': {
      id: '/_app/_authed/_sidebar/dev-playground'
      path: '/dev-playground'
      fullPath: '/dev-playground'
      preLoaderRoute: typeof AppAuthedSidebarDevPlaygroundRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agriculture': {
      id: '/_app/_authed/_sidebar/agriculture'
      path: '/agriculture'
      fullPath: '/agriculture'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureRouteRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/warehouse-positions/': {
      id: '/_app/_authed/_sidebar/warehouse-positions/'
      path: '/warehouse-positions'
      fullPath: '/warehouse-positions/'
      preLoaderRoute: typeof AppAuthedSidebarWarehousePositionsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/vehicles/': {
      id: '/_app/_authed/_sidebar/vehicles/'
      path: '/vehicles'
      fullPath: '/vehicles/'
      preLoaderRoute: typeof AppAuthedSidebarVehiclesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/users/': {
      id: '/_app/_authed/_sidebar/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppAuthedSidebarUsersIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/tea-purchases/': {
      id: '/_app/_authed/_sidebar/tea-purchases/'
      path: '/tea-purchases'
      fullPath: '/tea-purchases/'
      preLoaderRoute: typeof AppAuthedSidebarTeaPurchasesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/stocktake/': {
      id: '/_app/_authed/_sidebar/stocktake/'
      path: '/stocktake'
      fullPath: '/stocktake/'
      preLoaderRoute: typeof AppAuthedSidebarStocktakeIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/reports/': {
      id: '/_app/_authed/_sidebar/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AppAuthedSidebarReportsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/products/': {
      id: '/_app/_authed/_sidebar/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AppAuthedSidebarProductsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging/': {
      id: '/_app/_authed/_sidebar/packaging/'
      path: '/packaging'
      fullPath: '/packaging/'
      preLoaderRoute: typeof AppAuthedSidebarPackagingIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/orders/': {
      id: '/_app/_authed/_sidebar/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AppAuthedSidebarOrdersIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/delivery-trips/': {
      id: '/_app/_authed/_sidebar/delivery-trips/'
      path: '/delivery-trips'
      fullPath: '/delivery-trips/'
      preLoaderRoute: typeof AppAuthedSidebarDeliveryTripsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/customers/': {
      id: '/_app/_authed/_sidebar/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppAuthedSidebarCustomersIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/contract-deliveries/': {
      id: '/_app/_authed/_sidebar/contract-deliveries/'
      path: '/contract-deliveries'
      fullPath: '/contract-deliveries/'
      preLoaderRoute: typeof AppAuthedSidebarContractDeliveriesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/accounting/': {
      id: '/_app/_authed/_sidebar/accounting/'
      path: '/accounting'
      fullPath: '/accounting/'
      preLoaderRoute: typeof AppAuthedSidebarAccountingIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/warehouse-sales/stats': {
      id: '/_app/_authed/_sidebar/warehouse-sales/stats'
      path: '/warehouse-sales/stats'
      fullPath: '/warehouse-sales/stats'
      preLoaderRoute: typeof AppAuthedSidebarWarehouseSalesStatsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/warehouse-sales/defects': {
      id: '/_app/_authed/_sidebar/warehouse-sales/defects'
      path: '/warehouse-sales/defects'
      fullPath: '/warehouse-sales/defects'
      preLoaderRoute: typeof AppAuthedSidebarWarehouseSalesDefectsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/warehouse-sales/dashboard': {
      id: '/_app/_authed/_sidebar/warehouse-sales/dashboard'
      path: '/warehouse-sales/dashboard'
      fullPath: '/warehouse-sales/dashboard'
      preLoaderRoute: typeof AppAuthedSidebarWarehouseSalesDashboardRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/warehouse-positions/new': {
      id: '/_app/_authed/_sidebar/warehouse-positions/new'
      path: '/warehouse-positions/new'
      fullPath: '/warehouse-positions/new'
      preLoaderRoute: typeof AppAuthedSidebarWarehousePositionsNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/warehouse-positions/$id': {
      id: '/_app/_authed/_sidebar/warehouse-positions/$id'
      path: '/warehouse-positions/$id'
      fullPath: '/warehouse-positions/$id'
      preLoaderRoute: typeof AppAuthedSidebarWarehousePositionsIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/vehicles/$vehicleId': {
      id: '/_app/_authed/_sidebar/vehicles/$vehicleId'
      path: '/vehicles/$vehicleId'
      fullPath: '/vehicles/$vehicleId'
      preLoaderRoute: typeof AppAuthedSidebarVehiclesVehicleIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/tea-purchases/processing': {
      id: '/_app/_authed/_sidebar/tea-purchases/processing'
      path: '/tea-purchases/processing'
      fullPath: '/tea-purchases/processing'
      preLoaderRoute: typeof AppAuthedSidebarTeaPurchasesProcessingRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/tea-purchases/$id': {
      id: '/_app/_authed/_sidebar/tea-purchases/$id'
      path: '/tea-purchases/$id'
      fullPath: '/tea-purchases/$id'
      preLoaderRoute: typeof AppAuthedSidebarTeaPurchasesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/stocktake/new': {
      id: '/_app/_authed/_sidebar/stocktake/new'
      path: '/stocktake/new'
      fullPath: '/stocktake/new'
      preLoaderRoute: typeof AppAuthedSidebarStocktakeNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/stocktake/$id': {
      id: '/_app/_authed/_sidebar/stocktake/$id'
      path: '/stocktake/$id'
      fullPath: '/stocktake/$id'
      preLoaderRoute: typeof AppAuthedSidebarStocktakeIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/tea-grades': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/tea-grades'
      path: '/sorting-warehouse/tea-grades'
      fullPath: '/sorting-warehouse/tea-grades'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseTeaGradesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stats': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stats'
      path: '/sorting-warehouse/stats'
      fullPath: '/sorting-warehouse/stats'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStatsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/station-voice': {
      id: '/_app/_authed/_sidebar/settings/station-voice'
      path: '/settings/station-voice'
      fullPath: '/settings/station-voice'
      preLoaderRoute: typeof AppAuthedSidebarSettingsStationVoiceRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/sla': {
      id: '/_app/_authed/_sidebar/settings/sla'
      path: '/settings/sla'
      fullPath: '/settings/sla'
      preLoaderRoute: typeof AppAuthedSidebarSettingsSlaRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/sidebar-layout': {
      id: '/_app/_authed/_sidebar/settings/sidebar-layout'
      path: '/settings/sidebar-layout'
      fullPath: '/settings/sidebar-layout'
      preLoaderRoute: typeof AppAuthedSidebarSettingsSidebarLayoutRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/printing': {
      id: '/_app/_authed/_sidebar/settings/printing'
      path: '/settings/printing'
      fullPath: '/settings/printing'
      preLoaderRoute: typeof AppAuthedSidebarSettingsPrintingRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/notifications': {
      id: '/_app/_authed/_sidebar/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppAuthedSidebarSettingsNotificationsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/lot-sizes': {
      id: '/_app/_authed/_sidebar/settings/lot-sizes'
      path: '/settings/lot-sizes'
      fullPath: '/settings/lot-sizes'
      preLoaderRoute: typeof AppAuthedSidebarSettingsLotSizesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/settings/invoice': {
      id: '/_app/_authed/_sidebar/settings/invoice'
      path: '/settings/invoice'
      fullPath: '/settings/invoice'
      preLoaderRoute: typeof AppAuthedSidebarSettingsInvoiceRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stats': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stats'
      path: '/scenting-warehouse/stats'
      fullPath: '/scenting-warehouse/stats'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStatsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/purchase-lots/stats': {
      id: '/_app/_authed/_sidebar/purchase-lots/stats'
      path: '/purchase-lots/stats'
      fullPath: '/purchase-lots/stats'
      preLoaderRoute: typeof AppAuthedSidebarPurchaseLotsStatsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/products/new': {
      id: '/_app/_authed/_sidebar/products/new'
      path: '/products/new'
      fullPath: '/products/new'
      preLoaderRoute: typeof AppAuthedSidebarProductsNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/products/$productId': {
      id: '/_app/_authed/_sidebar/products/$productId'
      path: '/products/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof AppAuthedSidebarProductsProductIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stats': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stats'
      path: '/packaging-warehouse/stats'
      fullPath: '/packaging-warehouse/stats'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStatsRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/orders/quick': {
      id: '/_app/_authed/_sidebar/orders/quick'
      path: '/orders/quick'
      fullPath: '/orders/quick'
      preLoaderRoute: typeof AppAuthedSidebarOrdersQuickRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/orders/new': {
      id: '/_app/_authed/_sidebar/orders/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof AppAuthedSidebarOrdersNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/orders/$orderId': {
      id: '/_app/_authed/_sidebar/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AppAuthedSidebarOrdersOrderIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/logistics/shipping-carriers': {
      id: '/_app/_authed/_sidebar/logistics/shipping-carriers'
      path: '/logistics/shipping-carriers'
      fullPath: '/logistics/shipping-carriers'
      preLoaderRoute: typeof AppAuthedSidebarLogisticsShippingCarriersRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/driver/cash': {
      id: '/_app/_authed/_sidebar/driver/cash'
      path: '/driver/cash'
      fullPath: '/driver/cash'
      preLoaderRoute: typeof AppAuthedSidebarDriverCashRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/driver/available-orders': {
      id: '/_app/_authed/_sidebar/driver/available-orders'
      path: '/driver/available-orders'
      fullPath: '/driver/available-orders'
      preLoaderRoute: typeof AppAuthedSidebarDriverAvailableOrdersRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/delivery-trips/$id': {
      id: '/_app/_authed/_sidebar/delivery-trips/$id'
      path: '/delivery-trips/$id'
      fullPath: '/delivery-trips/$id'
      preLoaderRoute: typeof AppAuthedSidebarDeliveryTripsIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/customers/new': {
      id: '/_app/_authed/_sidebar/customers/new'
      path: '/customers/new'
      fullPath: '/customers/new'
      preLoaderRoute: typeof AppAuthedSidebarCustomersNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/customers/$customerId': {
      id: '/_app/_authed/_sidebar/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AppAuthedSidebarCustomersCustomerIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/contract-deliveries/new': {
      id: '/_app/_authed/_sidebar/contract-deliveries/new'
      path: '/contract-deliveries/new'
      fullPath: '/contract-deliveries/new'
      preLoaderRoute: typeof AppAuthedSidebarContractDeliveriesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/contract-deliveries/$id': {
      id: '/_app/_authed/_sidebar/contract-deliveries/$id'
      path: '/contract-deliveries/$id'
      fullPath: '/contract-deliveries/$id'
      preLoaderRoute: typeof AppAuthedSidebarContractDeliveriesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/agriculture/weighings': {
      id: '/_app/_authed/_sidebar/agriculture/weighings'
      path: '/weighings'
      fullPath: '/agriculture/weighings'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureWeighingsRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/tea-types': {
      id: '/_app/_authed/_sidebar/agriculture/tea-types'
      path: '/tea-types'
      fullPath: '/agriculture/tea-types'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureTeaTypesRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/tea-packages': {
      id: '/_app/_authed/_sidebar/agriculture/tea-packages'
      path: '/tea-packages'
      fullPath: '/agriculture/tea-packages'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureTeaPackagesRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/tea-lots': {
      id: '/_app/_authed/_sidebar/agriculture/tea-lots'
      path: '/tea-lots'
      fullPath: '/agriculture/tea-lots'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureTeaLotsRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/product-classifications': {
      id: '/_app/_authed/_sidebar/agriculture/product-classifications'
      path: '/product-classifications'
      fullPath: '/agriculture/product-classifications'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureProductClassificationsRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/phases': {
      id: '/_app/_authed/_sidebar/agriculture/phases'
      path: '/phases'
      fullPath: '/agriculture/phases'
      preLoaderRoute: typeof AppAuthedSidebarAgriculturePhasesRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/pesticides': {
      id: '/_app/_authed/_sidebar/agriculture/pesticides'
      path: '/pesticides'
      fullPath: '/agriculture/pesticides'
      preLoaderRoute: typeof AppAuthedSidebarAgriculturePesticidesRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/growers': {
      id: '/_app/_authed/_sidebar/agriculture/growers'
      path: '/growers'
      fullPath: '/agriculture/growers'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureGrowersRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/fertilizers': {
      id: '/_app/_authed/_sidebar/agriculture/fertilizers'
      path: '/fertilizers'
      fullPath: '/agriculture/fertilizers'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureFertilizersRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/care-logs': {
      id: '/_app/_authed/_sidebar/agriculture/care-logs'
      path: '/care-logs'
      fullPath: '/agriculture/care-logs'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureCareLogsRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/agriculture/aroma-samplings': {
      id: '/_app/_authed/_sidebar/agriculture/aroma-samplings'
      path: '/aroma-samplings'
      fullPath: '/agriculture/aroma-samplings'
      preLoaderRoute: typeof AppAuthedSidebarAgricultureAromaSamplingsRouteImport
      parentRoute: typeof AppAuthedSidebarAgricultureRouteRoute
    }
    '/_app/_authed/_sidebar/accounting/remittances': {
      id: '/_app/_authed/_sidebar/accounting/remittances'
      path: '/accounting/remittances'
      fullPath: '/accounting/remittances'
      preLoaderRoute: typeof AppAuthedSidebarAccountingRemittancesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/accounting/reconciliation': {
      id: '/_app/_authed/_sidebar/accounting/reconciliation'
      path: '/accounting/reconciliation'
      fullPath: '/accounting/reconciliation'
      preLoaderRoute: typeof AppAuthedSidebarAccountingReconciliationRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/accounting/expenses': {
      id: '/_app/_authed/_sidebar/accounting/expenses'
      path: '/accounting/expenses'
      fullPath: '/accounting/expenses'
      preLoaderRoute: typeof AppAuthedSidebarAccountingExpensesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/accounting/expense-sync': {
      id: '/_app/_authed/_sidebar/accounting/expense-sync'
      path: '/accounting/expense-sync'
      fullPath: '/accounting/expense-sync'
      preLoaderRoute: typeof AppAuthedSidebarAccountingExpenseSyncRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/accounting/expense-categories': {
      id: '/_app/_authed/_sidebar/accounting/expense-categories'
      path: '/accounting/expense-categories'
      fullPath: '/accounting/expense-categories'
      preLoaderRoute: typeof AppAuthedSidebarAccountingExpenseCategoriesRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/accounting/cash-flow': {
      id: '/_app/_authed/_sidebar/accounting/cash-flow'
      path: '/accounting/cash-flow'
      fullPath: '/accounting/cash-flow'
      preLoaderRoute: typeof AppAuthedSidebarAccountingCashFlowRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/'
      path: '/sorting-warehouse/withdrawal-notes'
      fullPath: '/sorting-warehouse/withdrawal-notes/'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/'
      path: '/sorting-warehouse/stock-out-notes'
      fullPath: '/sorting-warehouse/stock-out-notes/'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStockOutNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/'
      path: '/sorting-warehouse/stock-in-notes'
      fullPath: '/sorting-warehouse/stock-in-notes/'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStockInNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/lots/': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/lots/'
      path: '/sorting-warehouse/lots'
      fullPath: '/sorting-warehouse/lots/'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseLotsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/'
      path: '/scenting-warehouse/withdrawal-notes'
      fullPath: '/scenting-warehouse/withdrawal-notes/'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/'
      path: '/scenting-warehouse/stock-out-notes'
      fullPath: '/scenting-warehouse/stock-out-notes/'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStockOutNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/'
      path: '/scenting-warehouse/stock-in-notes'
      fullPath: '/scenting-warehouse/stock-in-notes/'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStockInNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/lots/': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/lots/'
      path: '/scenting-warehouse/lots'
      fullPath: '/scenting-warehouse/lots/'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseLotsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/'
      path: '/sales-warehouse/stock-out-notes'
      fullPath: '/sales-warehouse/stock-out-notes/'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockOutNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/'
      path: '/sales-warehouse/stock-in-notes'
      fullPath: '/sales-warehouse/stock-in-notes/'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/lots/': {
      id: '/_app/_authed/_sidebar/sales-warehouse/lots/'
      path: '/sales-warehouse/lots'
      fullPath: '/sales-warehouse/lots/'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseLotsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/purchase-lots/withdrawal-notes/': {
      id: '/_app/_authed/_sidebar/purchase-lots/withdrawal-notes/'
      path: '/purchase-lots/withdrawal-notes'
      fullPath: '/purchase-lots/withdrawal-notes/'
      preLoaderRoute: typeof AppAuthedSidebarPurchaseLotsWithdrawalNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/purchase-lots/stock-out-notes/': {
      id: '/_app/_authed/_sidebar/purchase-lots/stock-out-notes/'
      path: '/purchase-lots/stock-out-notes'
      fullPath: '/purchase-lots/stock-out-notes/'
      preLoaderRoute: typeof AppAuthedSidebarPurchaseLotsStockOutNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/purchase-lots/stock-in-notes/': {
      id: '/_app/_authed/_sidebar/purchase-lots/stock-in-notes/'
      path: '/purchase-lots/stock-in-notes'
      fullPath: '/purchase-lots/stock-in-notes/'
      preLoaderRoute: typeof AppAuthedSidebarPurchaseLotsStockInNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/purchase-lots/lots/': {
      id: '/_app/_authed/_sidebar/purchase-lots/lots/'
      path: '/purchase-lots/lots'
      fullPath: '/purchase-lots/lots/'
      preLoaderRoute: typeof AppAuthedSidebarPurchaseLotsLotsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/'
      path: '/packaging-warehouse/withdrawal-notes'
      fullPath: '/packaging-warehouse/withdrawal-notes/'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/'
      path: '/packaging-warehouse/stock-out-notes'
      fullPath: '/packaging-warehouse/stock-out-notes/'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/'
      path: '/packaging-warehouse/stock-in-notes'
      fullPath: '/packaging-warehouse/stock-in-notes/'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStockInNotesIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/lots/': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/lots/'
      path: '/packaging-warehouse/lots'
      fullPath: '/packaging-warehouse/lots/'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseLotsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/customers/groups/': {
      id: '/_app/_authed/_sidebar/customers/groups/'
      path: '/customers/groups'
      fullPath: '/customers/groups/'
      preLoaderRoute: typeof AppAuthedSidebarCustomersGroupsIndexRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/new': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/new'
      path: '/sorting-warehouse/withdrawal-notes/new'
      fullPath: '/sorting-warehouse/withdrawal-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/$id': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/withdrawal-notes/$id'
      path: '/sorting-warehouse/withdrawal-notes/$id'
      fullPath: '/sorting-warehouse/withdrawal-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/new': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/new'
      path: '/sorting-warehouse/stock-out-notes/new'
      fullPath: '/sorting-warehouse/stock-out-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStockOutNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id'
      path: '/sorting-warehouse/stock-out-notes/$id'
      fullPath: '/sorting-warehouse/stock-out-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/new': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/new'
      path: '/sorting-warehouse/stock-in-notes/new'
      fullPath: '/sorting-warehouse/stock-in-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStockInNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id'
      path: '/sorting-warehouse/stock-in-notes/$id'
      fullPath: '/sorting-warehouse/stock-in-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStockInNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/lots/$id': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/lots/$id'
      path: '/sorting-warehouse/lots/$id'
      fullPath: '/sorting-warehouse/lots/$id'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseLotsIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/new': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/new'
      path: '/scenting-warehouse/withdrawal-notes/new'
      fullPath: '/scenting-warehouse/withdrawal-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/$id': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/withdrawal-notes/$id'
      path: '/scenting-warehouse/withdrawal-notes/$id'
      fullPath: '/scenting-warehouse/withdrawal-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/new': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/new'
      path: '/scenting-warehouse/stock-out-notes/new'
      fullPath: '/scenting-warehouse/stock-out-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStockOutNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id'
      path: '/scenting-warehouse/stock-out-notes/$id'
      fullPath: '/scenting-warehouse/stock-out-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/new': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/new'
      path: '/scenting-warehouse/stock-in-notes/new'
      fullPath: '/scenting-warehouse/stock-in-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStockInNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id'
      path: '/scenting-warehouse/stock-in-notes/$id'
      fullPath: '/scenting-warehouse/stock-in-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStockInNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/lots/$id': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/lots/$id'
      path: '/scenting-warehouse/lots/$id'
      fullPath: '/scenting-warehouse/lots/$id'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseLotsIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/new': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/new'
      path: '/sales-warehouse/stock-out-notes/new'
      fullPath: '/sales-warehouse/stock-out-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockOutNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id'
      path: '/sales-warehouse/stock-out-notes/$id'
      fullPath: '/sales-warehouse/stock-out-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/quick': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/quick'
      path: '/sales-warehouse/stock-in-notes/quick'
      fullPath: '/sales-warehouse/stock-in-notes/quick'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesQuickRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/new': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/new'
      path: '/sales-warehouse/stock-in-notes/new'
      fullPath: '/sales-warehouse/stock-in-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id'
      path: '/sales-warehouse/stock-in-notes/$id'
      fullPath: '/sales-warehouse/stock-in-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/lots/$id': {
      id: '/_app/_authed/_sidebar/sales-warehouse/lots/$id'
      path: '/sales-warehouse/lots/$id'
      fullPath: '/sales-warehouse/lots/$id'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseLotsIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/purchase-lots/withdrawal-notes/new': {
      id: '/_app/_authed/_sidebar/purchase-lots/withdrawal-notes/new'
      path: '/purchase-lots/withdrawal-notes/new'
      fullPath: '/purchase-lots/withdrawal-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarPurchaseLotsWithdrawalNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/purchase-lots/withdrawal-notes/$id': {
      id: '/_app/_authed/_sidebar/purchase-lots/withdrawal-notes/$id'
      path: '/purchase-lots/withdrawal-notes/$id'
      fullPath: '/purchase-lots/withdrawal-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarPurchaseLotsWithdrawalNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/purchase-lots/stock-out-notes/new': {
      id: '/_app/_authed/_sidebar/purchase-lots/stock-out-notes/new'
      path: '/purchase-lots/stock-out-notes/new'
      fullPath: '/purchase-lots/stock-out-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarPurchaseLotsStockOutNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/purchase-lots/stock-out-notes/$id': {
      id: '/_app/_authed/_sidebar/purchase-lots/stock-out-notes/$id'
      path: '/purchase-lots/stock-out-notes/$id'
      fullPath: '/purchase-lots/stock-out-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarPurchaseLotsStockOutNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/purchase-lots/stock-in-notes/new': {
      id: '/_app/_authed/_sidebar/purchase-lots/stock-in-notes/new'
      path: '/purchase-lots/stock-in-notes/new'
      fullPath: '/purchase-lots/stock-in-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarPurchaseLotsStockInNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/purchase-lots/stock-in-notes/$id': {
      id: '/_app/_authed/_sidebar/purchase-lots/stock-in-notes/$id'
      path: '/purchase-lots/stock-in-notes/$id'
      fullPath: '/purchase-lots/stock-in-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarPurchaseLotsStockInNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/purchase-lots/lots/$id': {
      id: '/_app/_authed/_sidebar/purchase-lots/lots/$id'
      path: '/purchase-lots/lots/$id'
      fullPath: '/purchase-lots/lots/$id'
      preLoaderRoute: typeof AppAuthedSidebarPurchaseLotsLotsIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/new': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/new'
      path: '/packaging-warehouse/withdrawal-notes/new'
      fullPath: '/packaging-warehouse/withdrawal-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/$id': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/withdrawal-notes/$id'
      path: '/packaging-warehouse/withdrawal-notes/$id'
      fullPath: '/packaging-warehouse/withdrawal-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/new': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/new'
      path: '/packaging-warehouse/stock-out-notes/new'
      fullPath: '/packaging-warehouse/stock-out-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStockOutNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id'
      path: '/packaging-warehouse/stock-out-notes/$id'
      fullPath: '/packaging-warehouse/stock-out-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/new': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/new'
      path: '/packaging-warehouse/stock-in-notes/new'
      fullPath: '/packaging-warehouse/stock-in-notes/new'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStockInNotesNewRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id'
      path: '/packaging-warehouse/stock-in-notes/$id'
      fullPath: '/packaging-warehouse/stock-in-notes/$id'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/lots/$id': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/lots/$id'
      path: '/packaging-warehouse/lots/$id'
      fullPath: '/packaging-warehouse/lots/$id'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseLotsIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/customers/groups/$groupId': {
      id: '/_app/_authed/_sidebar/customers/groups/$groupId'
      path: '/customers/groups/$groupId'
      fullPath: '/customers/groups/$groupId'
      preLoaderRoute: typeof AppAuthedSidebarCustomersGroupsGroupIdRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/accounting/reports/daily': {
      id: '/_app/_authed/_sidebar/accounting/reports/daily'
      path: '/accounting/reports/daily'
      fullPath: '/accounting/reports/daily'
      preLoaderRoute: typeof AppAuthedSidebarAccountingReportsDailyRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stock-out-notes/$id_/edit'
      path: '/sorting-warehouse/stock-out-notes/$id/edit'
      fullPath: '/sorting-warehouse/stock-out-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/sorting-warehouse/stock-in-notes/$id_/edit'
      path: '/sorting-warehouse/stock-in-notes/$id/edit'
      fullPath: '/sorting-warehouse/stock-in-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarSortingWarehouseStockInNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stock-out-notes/$id_/edit'
      path: '/scenting-warehouse/stock-out-notes/$id/edit'
      fullPath: '/scenting-warehouse/stock-out-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/scenting-warehouse/stock-in-notes/$id_/edit'
      path: '/scenting-warehouse/stock-in-notes/$id/edit'
      fullPath: '/scenting-warehouse/stock-in-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarScentingWarehouseStockInNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-out-notes/$id_/edit'
      path: '/sales-warehouse/stock-out-notes/$id/edit'
      fullPath: '/sales-warehouse/stock-out-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/sales-warehouse/stock-in-notes/$id_/edit'
      path: '/sales-warehouse/stock-in-notes/$id/edit'
      fullPath: '/sales-warehouse/stock-in-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/purchase-lots/stock-out-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/purchase-lots/stock-out-notes/$id_/edit'
      path: '/purchase-lots/stock-out-notes/$id/edit'
      fullPath: '/purchase-lots/stock-out-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarPurchaseLotsStockOutNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/purchase-lots/stock-in-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/purchase-lots/stock-in-notes/$id_/edit'
      path: '/purchase-lots/stock-in-notes/$id/edit'
      fullPath: '/purchase-lots/stock-in-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarPurchaseLotsStockInNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stock-out-notes/$id_/edit'
      path: '/packaging-warehouse/stock-out-notes/$id/edit'
      fullPath: '/packaging-warehouse/stock-out-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
    '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id_/edit': {
      id: '/_app/_authed/_sidebar/packaging-warehouse/stock-in-notes/$id_/edit'
      path: '/packaging-warehouse/stock-in-notes/$id/edit'
      fullPath: '/packaging-warehouse/stock-in-notes/$id/edit'
      preLoaderRoute: typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRouteImport
      parentRoute: typeof AppAuthedSidebarRoute
    }
  }
}

interface AppAuthedSidebarAgricultureRouteRouteChildren {
  AppAuthedSidebarAgricultureAromaSamplingsRoute: typeof AppAuthedSidebarAgricultureAromaSamplingsRoute
  AppAuthedSidebarAgricultureCareLogsRoute: typeof AppAuthedSidebarAgricultureCareLogsRoute
  AppAuthedSidebarAgricultureFertilizersRoute: typeof AppAuthedSidebarAgricultureFertilizersRoute
  AppAuthedSidebarAgricultureGrowersRoute: typeof AppAuthedSidebarAgricultureGrowersRoute
  AppAuthedSidebarAgriculturePesticidesRoute: typeof AppAuthedSidebarAgriculturePesticidesRoute
  AppAuthedSidebarAgriculturePhasesRoute: typeof AppAuthedSidebarAgriculturePhasesRoute
  AppAuthedSidebarAgricultureProductClassificationsRoute: typeof AppAuthedSidebarAgricultureProductClassificationsRoute
  AppAuthedSidebarAgricultureTeaLotsRoute: typeof AppAuthedSidebarAgricultureTeaLotsRoute
  AppAuthedSidebarAgricultureTeaPackagesRoute: typeof AppAuthedSidebarAgricultureTeaPackagesRoute
  AppAuthedSidebarAgricultureTeaTypesRoute: typeof AppAuthedSidebarAgricultureTeaTypesRoute
  AppAuthedSidebarAgricultureWeighingsRoute: typeof AppAuthedSidebarAgricultureWeighingsRoute
}

const AppAuthedSidebarAgricultureRouteRouteChildren: AppAuthedSidebarAgricultureRouteRouteChildren =
  {
    AppAuthedSidebarAgricultureAromaSamplingsRoute:
      AppAuthedSidebarAgricultureAromaSamplingsRoute,
    AppAuthedSidebarAgricultureCareLogsRoute:
      AppAuthedSidebarAgricultureCareLogsRoute,
    AppAuthedSidebarAgricultureFertilizersRoute:
      AppAuthedSidebarAgricultureFertilizersRoute,
    AppAuthedSidebarAgricultureGrowersRoute:
      AppAuthedSidebarAgricultureGrowersRoute,
    AppAuthedSidebarAgriculturePesticidesRoute:
      AppAuthedSidebarAgriculturePesticidesRoute,
    AppAuthedSidebarAgriculturePhasesRoute:
      AppAuthedSidebarAgriculturePhasesRoute,
    AppAuthedSidebarAgricultureProductClassificationsRoute:
      AppAuthedSidebarAgricultureProductClassificationsRoute,
    AppAuthedSidebarAgricultureTeaLotsRoute:
      AppAuthedSidebarAgricultureTeaLotsRoute,
    AppAuthedSidebarAgricultureTeaPackagesRoute:
      AppAuthedSidebarAgricultureTeaPackagesRoute,
    AppAuthedSidebarAgricultureTeaTypesRoute:
      AppAuthedSidebarAgricultureTeaTypesRoute,
    AppAuthedSidebarAgricultureWeighingsRoute:
      AppAuthedSidebarAgricultureWeighingsRoute,
  }

const AppAuthedSidebarAgricultureRouteRouteWithChildren =
  AppAuthedSidebarAgricultureRouteRoute._addFileChildren(
    AppAuthedSidebarAgricultureRouteRouteChildren,
  )

interface AppAuthedSidebarRouteChildren {
  AppAuthedSidebarAgricultureRouteRoute: typeof AppAuthedSidebarAgricultureRouteRouteWithChildren
  AppAuthedSidebarDevPlaygroundRoute: typeof AppAuthedSidebarDevPlaygroundRoute
  AppAuthedSidebarTrackingRoute: typeof AppAuthedSidebarTrackingRoute
  AppAuthedSidebarWarehouseStatsRoute: typeof AppAuthedSidebarWarehouseStatsRoute
  AppAuthedSidebarWhatsNewRoute: typeof AppAuthedSidebarWhatsNewRoute
  AppAuthedSidebarIndexRoute: typeof AppAuthedSidebarIndexRoute
  AppAuthedSidebarAccountingCashFlowRoute: typeof AppAuthedSidebarAccountingCashFlowRoute
  AppAuthedSidebarAccountingExpenseCategoriesRoute: typeof AppAuthedSidebarAccountingExpenseCategoriesRoute
  AppAuthedSidebarAccountingExpenseSyncRoute: typeof AppAuthedSidebarAccountingExpenseSyncRoute
  AppAuthedSidebarAccountingExpensesRoute: typeof AppAuthedSidebarAccountingExpensesRoute
  AppAuthedSidebarAccountingReconciliationRoute: typeof AppAuthedSidebarAccountingReconciliationRoute
  AppAuthedSidebarAccountingRemittancesRoute: typeof AppAuthedSidebarAccountingRemittancesRoute
  AppAuthedSidebarContractDeliveriesIdRoute: typeof AppAuthedSidebarContractDeliveriesIdRoute
  AppAuthedSidebarContractDeliveriesNewRoute: typeof AppAuthedSidebarContractDeliveriesNewRoute
  AppAuthedSidebarCustomersCustomerIdRoute: typeof AppAuthedSidebarCustomersCustomerIdRoute
  AppAuthedSidebarCustomersNewRoute: typeof AppAuthedSidebarCustomersNewRoute
  AppAuthedSidebarDeliveryTripsIdRoute: typeof AppAuthedSidebarDeliveryTripsIdRoute
  AppAuthedSidebarDriverAvailableOrdersRoute: typeof AppAuthedSidebarDriverAvailableOrdersRoute
  AppAuthedSidebarDriverCashRoute: typeof AppAuthedSidebarDriverCashRoute
  AppAuthedSidebarLogisticsShippingCarriersRoute: typeof AppAuthedSidebarLogisticsShippingCarriersRoute
  AppAuthedSidebarOrdersOrderIdRoute: typeof AppAuthedSidebarOrdersOrderIdRoute
  AppAuthedSidebarOrdersNewRoute: typeof AppAuthedSidebarOrdersNewRoute
  AppAuthedSidebarOrdersQuickRoute: typeof AppAuthedSidebarOrdersQuickRoute
  AppAuthedSidebarPackagingWarehouseStatsRoute: typeof AppAuthedSidebarPackagingWarehouseStatsRoute
  AppAuthedSidebarProductsProductIdRoute: typeof AppAuthedSidebarProductsProductIdRoute
  AppAuthedSidebarProductsNewRoute: typeof AppAuthedSidebarProductsNewRoute
  AppAuthedSidebarPurchaseLotsStatsRoute: typeof AppAuthedSidebarPurchaseLotsStatsRoute
  AppAuthedSidebarScentingWarehouseStatsRoute: typeof AppAuthedSidebarScentingWarehouseStatsRoute
  AppAuthedSidebarSettingsInvoiceRoute: typeof AppAuthedSidebarSettingsInvoiceRoute
  AppAuthedSidebarSettingsLotSizesRoute: typeof AppAuthedSidebarSettingsLotSizesRoute
  AppAuthedSidebarSettingsNotificationsRoute: typeof AppAuthedSidebarSettingsNotificationsRoute
  AppAuthedSidebarSettingsPrintingRoute: typeof AppAuthedSidebarSettingsPrintingRoute
  AppAuthedSidebarSettingsSidebarLayoutRoute: typeof AppAuthedSidebarSettingsSidebarLayoutRoute
  AppAuthedSidebarSettingsSlaRoute: typeof AppAuthedSidebarSettingsSlaRoute
  AppAuthedSidebarSettingsStationVoiceRoute: typeof AppAuthedSidebarSettingsStationVoiceRoute
  AppAuthedSidebarSortingWarehouseStatsRoute: typeof AppAuthedSidebarSortingWarehouseStatsRoute
  AppAuthedSidebarSortingWarehouseTeaGradesRoute: typeof AppAuthedSidebarSortingWarehouseTeaGradesRoute
  AppAuthedSidebarStocktakeIdRoute: typeof AppAuthedSidebarStocktakeIdRoute
  AppAuthedSidebarStocktakeNewRoute: typeof AppAuthedSidebarStocktakeNewRoute
  AppAuthedSidebarTeaPurchasesIdRoute: typeof AppAuthedSidebarTeaPurchasesIdRoute
  AppAuthedSidebarTeaPurchasesProcessingRoute: typeof AppAuthedSidebarTeaPurchasesProcessingRoute
  AppAuthedSidebarVehiclesVehicleIdRoute: typeof AppAuthedSidebarVehiclesVehicleIdRoute
  AppAuthedSidebarWarehousePositionsIdRoute: typeof AppAuthedSidebarWarehousePositionsIdRoute
  AppAuthedSidebarWarehousePositionsNewRoute: typeof AppAuthedSidebarWarehousePositionsNewRoute
  AppAuthedSidebarWarehouseSalesDashboardRoute: typeof AppAuthedSidebarWarehouseSalesDashboardRoute
  AppAuthedSidebarWarehouseSalesDefectsRoute: typeof AppAuthedSidebarWarehouseSalesDefectsRoute
  AppAuthedSidebarWarehouseSalesStatsRoute: typeof AppAuthedSidebarWarehouseSalesStatsRoute
  AppAuthedSidebarAccountingIndexRoute: typeof AppAuthedSidebarAccountingIndexRoute
  AppAuthedSidebarContractDeliveriesIndexRoute: typeof AppAuthedSidebarContractDeliveriesIndexRoute
  AppAuthedSidebarCustomersIndexRoute: typeof AppAuthedSidebarCustomersIndexRoute
  AppAuthedSidebarDeliveryTripsIndexRoute: typeof AppAuthedSidebarDeliveryTripsIndexRoute
  AppAuthedSidebarOrdersIndexRoute: typeof AppAuthedSidebarOrdersIndexRoute
  AppAuthedSidebarPackagingIndexRoute: typeof AppAuthedSidebarPackagingIndexRoute
  AppAuthedSidebarProductsIndexRoute: typeof AppAuthedSidebarProductsIndexRoute
  AppAuthedSidebarReportsIndexRoute: typeof AppAuthedSidebarReportsIndexRoute
  AppAuthedSidebarStocktakeIndexRoute: typeof AppAuthedSidebarStocktakeIndexRoute
  AppAuthedSidebarTeaPurchasesIndexRoute: typeof AppAuthedSidebarTeaPurchasesIndexRoute
  AppAuthedSidebarUsersIndexRoute: typeof AppAuthedSidebarUsersIndexRoute
  AppAuthedSidebarVehiclesIndexRoute: typeof AppAuthedSidebarVehiclesIndexRoute
  AppAuthedSidebarWarehousePositionsIndexRoute: typeof AppAuthedSidebarWarehousePositionsIndexRoute
  AppAuthedSidebarAccountingReportsDailyRoute: typeof AppAuthedSidebarAccountingReportsDailyRoute
  AppAuthedSidebarCustomersGroupsGroupIdRoute: typeof AppAuthedSidebarCustomersGroupsGroupIdRoute
  AppAuthedSidebarPackagingWarehouseLotsIdRoute: typeof AppAuthedSidebarPackagingWarehouseLotsIdRoute
  AppAuthedSidebarPackagingWarehouseStockInNotesIdRoute: typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdRoute
  AppAuthedSidebarPackagingWarehouseStockInNotesNewRoute: typeof AppAuthedSidebarPackagingWarehouseStockInNotesNewRoute
  AppAuthedSidebarPackagingWarehouseStockOutNotesIdRoute: typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdRoute
  AppAuthedSidebarPackagingWarehouseStockOutNotesNewRoute: typeof AppAuthedSidebarPackagingWarehouseStockOutNotesNewRoute
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRoute: typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRoute
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRoute: typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRoute
  AppAuthedSidebarPurchaseLotsLotsIdRoute: typeof AppAuthedSidebarPurchaseLotsLotsIdRoute
  AppAuthedSidebarPurchaseLotsStockInNotesIdRoute: typeof AppAuthedSidebarPurchaseLotsStockInNotesIdRoute
  AppAuthedSidebarPurchaseLotsStockInNotesNewRoute: typeof AppAuthedSidebarPurchaseLotsStockInNotesNewRoute
  AppAuthedSidebarPurchaseLotsStockOutNotesIdRoute: typeof AppAuthedSidebarPurchaseLotsStockOutNotesIdRoute
  AppAuthedSidebarPurchaseLotsStockOutNotesNewRoute: typeof AppAuthedSidebarPurchaseLotsStockOutNotesNewRoute
  AppAuthedSidebarPurchaseLotsWithdrawalNotesIdRoute: typeof AppAuthedSidebarPurchaseLotsWithdrawalNotesIdRoute
  AppAuthedSidebarPurchaseLotsWithdrawalNotesNewRoute: typeof AppAuthedSidebarPurchaseLotsWithdrawalNotesNewRoute
  AppAuthedSidebarSalesWarehouseLotsIdRoute: typeof AppAuthedSidebarSalesWarehouseLotsIdRoute
  AppAuthedSidebarSalesWarehouseStockInNotesIdRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesIdRoute
  AppAuthedSidebarSalesWarehouseStockInNotesNewRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesNewRoute
  AppAuthedSidebarSalesWarehouseStockInNotesQuickRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesQuickRoute
  AppAuthedSidebarSalesWarehouseStockOutNotesIdRoute: typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdRoute
  AppAuthedSidebarSalesWarehouseStockOutNotesNewRoute: typeof AppAuthedSidebarSalesWarehouseStockOutNotesNewRoute
  AppAuthedSidebarScentingWarehouseLotsIdRoute: typeof AppAuthedSidebarScentingWarehouseLotsIdRoute
  AppAuthedSidebarScentingWarehouseStockInNotesIdRoute: typeof AppAuthedSidebarScentingWarehouseStockInNotesIdRoute
  AppAuthedSidebarScentingWarehouseStockInNotesNewRoute: typeof AppAuthedSidebarScentingWarehouseStockInNotesNewRoute
  AppAuthedSidebarScentingWarehouseStockOutNotesIdRoute: typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdRoute
  AppAuthedSidebarScentingWarehouseStockOutNotesNewRoute: typeof AppAuthedSidebarScentingWarehouseStockOutNotesNewRoute
  AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRoute: typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRoute
  AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRoute: typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRoute
  AppAuthedSidebarSortingWarehouseLotsIdRoute: typeof AppAuthedSidebarSortingWarehouseLotsIdRoute
  AppAuthedSidebarSortingWarehouseStockInNotesIdRoute: typeof AppAuthedSidebarSortingWarehouseStockInNotesIdRoute
  AppAuthedSidebarSortingWarehouseStockInNotesNewRoute: typeof AppAuthedSidebarSortingWarehouseStockInNotesNewRoute
  AppAuthedSidebarSortingWarehouseStockOutNotesIdRoute: typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdRoute
  AppAuthedSidebarSortingWarehouseStockOutNotesNewRoute: typeof AppAuthedSidebarSortingWarehouseStockOutNotesNewRoute
  AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRoute: typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRoute
  AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRoute: typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRoute
  AppAuthedSidebarCustomersGroupsIndexRoute: typeof AppAuthedSidebarCustomersGroupsIndexRoute
  AppAuthedSidebarPackagingWarehouseLotsIndexRoute: typeof AppAuthedSidebarPackagingWarehouseLotsIndexRoute
  AppAuthedSidebarPackagingWarehouseStockInNotesIndexRoute: typeof AppAuthedSidebarPackagingWarehouseStockInNotesIndexRoute
  AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRoute: typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRoute
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRoute: typeof AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRoute
  AppAuthedSidebarPurchaseLotsLotsIndexRoute: typeof AppAuthedSidebarPurchaseLotsLotsIndexRoute
  AppAuthedSidebarPurchaseLotsStockInNotesIndexRoute: typeof AppAuthedSidebarPurchaseLotsStockInNotesIndexRoute
  AppAuthedSidebarPurchaseLotsStockOutNotesIndexRoute: typeof AppAuthedSidebarPurchaseLotsStockOutNotesIndexRoute
  AppAuthedSidebarPurchaseLotsWithdrawalNotesIndexRoute: typeof AppAuthedSidebarPurchaseLotsWithdrawalNotesIndexRoute
  AppAuthedSidebarSalesWarehouseLotsIndexRoute: typeof AppAuthedSidebarSalesWarehouseLotsIndexRoute
  AppAuthedSidebarSalesWarehouseStockInNotesIndexRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesIndexRoute
  AppAuthedSidebarSalesWarehouseStockOutNotesIndexRoute: typeof AppAuthedSidebarSalesWarehouseStockOutNotesIndexRoute
  AppAuthedSidebarScentingWarehouseLotsIndexRoute: typeof AppAuthedSidebarScentingWarehouseLotsIndexRoute
  AppAuthedSidebarScentingWarehouseStockInNotesIndexRoute: typeof AppAuthedSidebarScentingWarehouseStockInNotesIndexRoute
  AppAuthedSidebarScentingWarehouseStockOutNotesIndexRoute: typeof AppAuthedSidebarScentingWarehouseStockOutNotesIndexRoute
  AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRoute: typeof AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRoute
  AppAuthedSidebarSortingWarehouseLotsIndexRoute: typeof AppAuthedSidebarSortingWarehouseLotsIndexRoute
  AppAuthedSidebarSortingWarehouseStockInNotesIndexRoute: typeof AppAuthedSidebarSortingWarehouseStockInNotesIndexRoute
  AppAuthedSidebarSortingWarehouseStockOutNotesIndexRoute: typeof AppAuthedSidebarSortingWarehouseStockOutNotesIndexRoute
  AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRoute: typeof AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRoute
  AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRoute: typeof AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRoute
  AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRoute: typeof AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRoute
  AppAuthedSidebarPurchaseLotsStockInNotesIdEditRoute: typeof AppAuthedSidebarPurchaseLotsStockInNotesIdEditRoute
  AppAuthedSidebarPurchaseLotsStockOutNotesIdEditRoute: typeof AppAuthedSidebarPurchaseLotsStockOutNotesIdEditRoute
  AppAuthedSidebarSalesWarehouseStockInNotesIdEditRoute: typeof AppAuthedSidebarSalesWarehouseStockInNotesIdEditRoute
  AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRoute: typeof AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRoute
  AppAuthedSidebarScentingWarehouseStockInNotesIdEditRoute: typeof AppAuthedSidebarScentingWarehouseStockInNotesIdEditRoute
  AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRoute: typeof AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRoute
  AppAuthedSidebarSortingWarehouseStockInNotesIdEditRoute: typeof AppAuthedSidebarSortingWarehouseStockInNotesIdEditRoute
  AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRoute: typeof AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRoute
}

const AppAuthedSidebarRouteChildren: AppAuthedSidebarRouteChildren = {
  AppAuthedSidebarAgricultureRouteRoute:
    AppAuthedSidebarAgricultureRouteRouteWithChildren,
  AppAuthedSidebarDevPlaygroundRoute: AppAuthedSidebarDevPlaygroundRoute,
  AppAuthedSidebarTrackingRoute: AppAuthedSidebarTrackingRoute,
  AppAuthedSidebarWarehouseStatsRoute: AppAuthedSidebarWarehouseStatsRoute,
  AppAuthedSidebarWhatsNewRoute: AppAuthedSidebarWhatsNewRoute,
  AppAuthedSidebarIndexRoute: AppAuthedSidebarIndexRoute,
  AppAuthedSidebarAccountingCashFlowRoute:
    AppAuthedSidebarAccountingCashFlowRoute,
  AppAuthedSidebarAccountingExpenseCategoriesRoute:
    AppAuthedSidebarAccountingExpenseCategoriesRoute,
  AppAuthedSidebarAccountingExpenseSyncRoute:
    AppAuthedSidebarAccountingExpenseSyncRoute,
  AppAuthedSidebarAccountingExpensesRoute:
    AppAuthedSidebarAccountingExpensesRoute,
  AppAuthedSidebarAccountingReconciliationRoute:
    AppAuthedSidebarAccountingReconciliationRoute,
  AppAuthedSidebarAccountingRemittancesRoute:
    AppAuthedSidebarAccountingRemittancesRoute,
  AppAuthedSidebarContractDeliveriesIdRoute:
    AppAuthedSidebarContractDeliveriesIdRoute,
  AppAuthedSidebarContractDeliveriesNewRoute:
    AppAuthedSidebarContractDeliveriesNewRoute,
  AppAuthedSidebarCustomersCustomerIdRoute:
    AppAuthedSidebarCustomersCustomerIdRoute,
  AppAuthedSidebarCustomersNewRoute: AppAuthedSidebarCustomersNewRoute,
  AppAuthedSidebarDeliveryTripsIdRoute: AppAuthedSidebarDeliveryTripsIdRoute,
  AppAuthedSidebarDriverAvailableOrdersRoute:
    AppAuthedSidebarDriverAvailableOrdersRoute,
  AppAuthedSidebarDriverCashRoute: AppAuthedSidebarDriverCashRoute,
  AppAuthedSidebarLogisticsShippingCarriersRoute:
    AppAuthedSidebarLogisticsShippingCarriersRoute,
  AppAuthedSidebarOrdersOrderIdRoute: AppAuthedSidebarOrdersOrderIdRoute,
  AppAuthedSidebarOrdersNewRoute: AppAuthedSidebarOrdersNewRoute,
  AppAuthedSidebarOrdersQuickRoute: AppAuthedSidebarOrdersQuickRoute,
  AppAuthedSidebarPackagingWarehouseStatsRoute:
    AppAuthedSidebarPackagingWarehouseStatsRoute,
  AppAuthedSidebarProductsProductIdRoute:
    AppAuthedSidebarProductsProductIdRoute,
  AppAuthedSidebarProductsNewRoute: AppAuthedSidebarProductsNewRoute,
  AppAuthedSidebarPurchaseLotsStatsRoute:
    AppAuthedSidebarPurchaseLotsStatsRoute,
  AppAuthedSidebarScentingWarehouseStatsRoute:
    AppAuthedSidebarScentingWarehouseStatsRoute,
  AppAuthedSidebarSettingsInvoiceRoute: AppAuthedSidebarSettingsInvoiceRoute,
  AppAuthedSidebarSettingsLotSizesRoute: AppAuthedSidebarSettingsLotSizesRoute,
  AppAuthedSidebarSettingsNotificationsRoute:
    AppAuthedSidebarSettingsNotificationsRoute,
  AppAuthedSidebarSettingsPrintingRoute: AppAuthedSidebarSettingsPrintingRoute,
  AppAuthedSidebarSettingsSidebarLayoutRoute:
    AppAuthedSidebarSettingsSidebarLayoutRoute,
  AppAuthedSidebarSettingsSlaRoute: AppAuthedSidebarSettingsSlaRoute,
  AppAuthedSidebarSettingsStationVoiceRoute:
    AppAuthedSidebarSettingsStationVoiceRoute,
  AppAuthedSidebarSortingWarehouseStatsRoute:
    AppAuthedSidebarSortingWarehouseStatsRoute,
  AppAuthedSidebarSortingWarehouseTeaGradesRoute:
    AppAuthedSidebarSortingWarehouseTeaGradesRoute,
  AppAuthedSidebarStocktakeIdRoute: AppAuthedSidebarStocktakeIdRoute,
  AppAuthedSidebarStocktakeNewRoute: AppAuthedSidebarStocktakeNewRoute,
  AppAuthedSidebarTeaPurchasesIdRoute: AppAuthedSidebarTeaPurchasesIdRoute,
  AppAuthedSidebarTeaPurchasesProcessingRoute:
    AppAuthedSidebarTeaPurchasesProcessingRoute,
  AppAuthedSidebarVehiclesVehicleIdRoute:
    AppAuthedSidebarVehiclesVehicleIdRoute,
  AppAuthedSidebarWarehousePositionsIdRoute:
    AppAuthedSidebarWarehousePositionsIdRoute,
  AppAuthedSidebarWarehousePositionsNewRoute:
    AppAuthedSidebarWarehousePositionsNewRoute,
  AppAuthedSidebarWarehouseSalesDashboardRoute:
    AppAuthedSidebarWarehouseSalesDashboardRoute,
  AppAuthedSidebarWarehouseSalesDefectsRoute:
    AppAuthedSidebarWarehouseSalesDefectsRoute,
  AppAuthedSidebarWarehouseSalesStatsRoute:
    AppAuthedSidebarWarehouseSalesStatsRoute,
  AppAuthedSidebarAccountingIndexRoute: AppAuthedSidebarAccountingIndexRoute,
  AppAuthedSidebarContractDeliveriesIndexRoute:
    AppAuthedSidebarContractDeliveriesIndexRoute,
  AppAuthedSidebarCustomersIndexRoute: AppAuthedSidebarCustomersIndexRoute,
  AppAuthedSidebarDeliveryTripsIndexRoute:
    AppAuthedSidebarDeliveryTripsIndexRoute,
  AppAuthedSidebarOrdersIndexRoute: AppAuthedSidebarOrdersIndexRoute,
  AppAuthedSidebarPackagingIndexRoute: AppAuthedSidebarPackagingIndexRoute,
  AppAuthedSidebarProductsIndexRoute: AppAuthedSidebarProductsIndexRoute,
  AppAuthedSidebarReportsIndexRoute: AppAuthedSidebarReportsIndexRoute,
  AppAuthedSidebarStocktakeIndexRoute: AppAuthedSidebarStocktakeIndexRoute,
  AppAuthedSidebarTeaPurchasesIndexRoute:
    AppAuthedSidebarTeaPurchasesIndexRoute,
  AppAuthedSidebarUsersIndexRoute: AppAuthedSidebarUsersIndexRoute,
  AppAuthedSidebarVehiclesIndexRoute: AppAuthedSidebarVehiclesIndexRoute,
  AppAuthedSidebarWarehousePositionsIndexRoute:
    AppAuthedSidebarWarehousePositionsIndexRoute,
  AppAuthedSidebarAccountingReportsDailyRoute:
    AppAuthedSidebarAccountingReportsDailyRoute,
  AppAuthedSidebarCustomersGroupsGroupIdRoute:
    AppAuthedSidebarCustomersGroupsGroupIdRoute,
  AppAuthedSidebarPackagingWarehouseLotsIdRoute:
    AppAuthedSidebarPackagingWarehouseLotsIdRoute,
  AppAuthedSidebarPackagingWarehouseStockInNotesIdRoute:
    AppAuthedSidebarPackagingWarehouseStockInNotesIdRoute,
  AppAuthedSidebarPackagingWarehouseStockInNotesNewRoute:
    AppAuthedSidebarPackagingWarehouseStockInNotesNewRoute,
  AppAuthedSidebarPackagingWarehouseStockOutNotesIdRoute:
    AppAuthedSidebarPackagingWarehouseStockOutNotesIdRoute,
  AppAuthedSidebarPackagingWarehouseStockOutNotesNewRoute:
    AppAuthedSidebarPackagingWarehouseStockOutNotesNewRoute,
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRoute:
    AppAuthedSidebarPackagingWarehouseWithdrawalNotesIdRoute,
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRoute:
    AppAuthedSidebarPackagingWarehouseWithdrawalNotesNewRoute,
  AppAuthedSidebarPurchaseLotsLotsIdRoute:
    AppAuthedSidebarPurchaseLotsLotsIdRoute,
  AppAuthedSidebarPurchaseLotsStockInNotesIdRoute:
    AppAuthedSidebarPurchaseLotsStockInNotesIdRoute,
  AppAuthedSidebarPurchaseLotsStockInNotesNewRoute:
    AppAuthedSidebarPurchaseLotsStockInNotesNewRoute,
  AppAuthedSidebarPurchaseLotsStockOutNotesIdRoute:
    AppAuthedSidebarPurchaseLotsStockOutNotesIdRoute,
  AppAuthedSidebarPurchaseLotsStockOutNotesNewRoute:
    AppAuthedSidebarPurchaseLotsStockOutNotesNewRoute,
  AppAuthedSidebarPurchaseLotsWithdrawalNotesIdRoute:
    AppAuthedSidebarPurchaseLotsWithdrawalNotesIdRoute,
  AppAuthedSidebarPurchaseLotsWithdrawalNotesNewRoute:
    AppAuthedSidebarPurchaseLotsWithdrawalNotesNewRoute,
  AppAuthedSidebarSalesWarehouseLotsIdRoute:
    AppAuthedSidebarSalesWarehouseLotsIdRoute,
  AppAuthedSidebarSalesWarehouseStockInNotesIdRoute:
    AppAuthedSidebarSalesWarehouseStockInNotesIdRoute,
  AppAuthedSidebarSalesWarehouseStockInNotesNewRoute:
    AppAuthedSidebarSalesWarehouseStockInNotesNewRoute,
  AppAuthedSidebarSalesWarehouseStockInNotesQuickRoute:
    AppAuthedSidebarSalesWarehouseStockInNotesQuickRoute,
  AppAuthedSidebarSalesWarehouseStockOutNotesIdRoute:
    AppAuthedSidebarSalesWarehouseStockOutNotesIdRoute,
  AppAuthedSidebarSalesWarehouseStockOutNotesNewRoute:
    AppAuthedSidebarSalesWarehouseStockOutNotesNewRoute,
  AppAuthedSidebarScentingWarehouseLotsIdRoute:
    AppAuthedSidebarScentingWarehouseLotsIdRoute,
  AppAuthedSidebarScentingWarehouseStockInNotesIdRoute:
    AppAuthedSidebarScentingWarehouseStockInNotesIdRoute,
  AppAuthedSidebarScentingWarehouseStockInNotesNewRoute:
    AppAuthedSidebarScentingWarehouseStockInNotesNewRoute,
  AppAuthedSidebarScentingWarehouseStockOutNotesIdRoute:
    AppAuthedSidebarScentingWarehouseStockOutNotesIdRoute,
  AppAuthedSidebarScentingWarehouseStockOutNotesNewRoute:
    AppAuthedSidebarScentingWarehouseStockOutNotesNewRoute,
  AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRoute:
    AppAuthedSidebarScentingWarehouseWithdrawalNotesIdRoute,
  AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRoute:
    AppAuthedSidebarScentingWarehouseWithdrawalNotesNewRoute,
  AppAuthedSidebarSortingWarehouseLotsIdRoute:
    AppAuthedSidebarSortingWarehouseLotsIdRoute,
  AppAuthedSidebarSortingWarehouseStockInNotesIdRoute:
    AppAuthedSidebarSortingWarehouseStockInNotesIdRoute,
  AppAuthedSidebarSortingWarehouseStockInNotesNewRoute:
    AppAuthedSidebarSortingWarehouseStockInNotesNewRoute,
  AppAuthedSidebarSortingWarehouseStockOutNotesIdRoute:
    AppAuthedSidebarSortingWarehouseStockOutNotesIdRoute,
  AppAuthedSidebarSortingWarehouseStockOutNotesNewRoute:
    AppAuthedSidebarSortingWarehouseStockOutNotesNewRoute,
  AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRoute:
    AppAuthedSidebarSortingWarehouseWithdrawalNotesIdRoute,
  AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRoute:
    AppAuthedSidebarSortingWarehouseWithdrawalNotesNewRoute,
  AppAuthedSidebarCustomersGroupsIndexRoute:
    AppAuthedSidebarCustomersGroupsIndexRoute,
  AppAuthedSidebarPackagingWarehouseLotsIndexRoute:
    AppAuthedSidebarPackagingWarehouseLotsIndexRoute,
  AppAuthedSidebarPackagingWarehouseStockInNotesIndexRoute:
    AppAuthedSidebarPackagingWarehouseStockInNotesIndexRoute,
  AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRoute:
    AppAuthedSidebarPackagingWarehouseStockOutNotesIndexRoute,
  AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRoute:
    AppAuthedSidebarPackagingWarehouseWithdrawalNotesIndexRoute,
  AppAuthedSidebarPurchaseLotsLotsIndexRoute:
    AppAuthedSidebarPurchaseLotsLotsIndexRoute,
  AppAuthedSidebarPurchaseLotsStockInNotesIndexRoute:
    AppAuthedSidebarPurchaseLotsStockInNotesIndexRoute,
  AppAuthedSidebarPurchaseLotsStockOutNotesIndexRoute:
    AppAuthedSidebarPurchaseLotsStockOutNotesIndexRoute,
  AppAuthedSidebarPurchaseLotsWithdrawalNotesIndexRoute:
    AppAuthedSidebarPurchaseLotsWithdrawalNotesIndexRoute,
  AppAuthedSidebarSalesWarehouseLotsIndexRoute:
    AppAuthedSidebarSalesWarehouseLotsIndexRoute,
  AppAuthedSidebarSalesWarehouseStockInNotesIndexRoute:
    AppAuthedSidebarSalesWarehouseStockInNotesIndexRoute,
  AppAuthedSidebarSalesWarehouseStockOutNotesIndexRoute:
    AppAuthedSidebarSalesWarehouseStockOutNotesIndexRoute,
  AppAuthedSidebarScentingWarehouseLotsIndexRoute:
    AppAuthedSidebarScentingWarehouseLotsIndexRoute,
  AppAuthedSidebarScentingWarehouseStockInNotesIndexRoute:
    AppAuthedSidebarScentingWarehouseStockInNotesIndexRoute,
  AppAuthedSidebarScentingWarehouseStockOutNotesIndexRoute:
    AppAuthedSidebarScentingWarehouseStockOutNotesIndexRoute,
  AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRoute:
    AppAuthedSidebarScentingWarehouseWithdrawalNotesIndexRoute,
  AppAuthedSidebarSortingWarehouseLotsIndexRoute:
    AppAuthedSidebarSortingWarehouseLotsIndexRoute,
  AppAuthedSidebarSortingWarehouseStockInNotesIndexRoute:
    AppAuthedSidebarSortingWarehouseStockInNotesIndexRoute,
  AppAuthedSidebarSortingWarehouseStockOutNotesIndexRoute:
    AppAuthedSidebarSortingWarehouseStockOutNotesIndexRoute,
  AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRoute:
    AppAuthedSidebarSortingWarehouseWithdrawalNotesIndexRoute,
  AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRoute:
    AppAuthedSidebarPackagingWarehouseStockInNotesIdEditRoute,
  AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRoute:
    AppAuthedSidebarPackagingWarehouseStockOutNotesIdEditRoute,
  AppAuthedSidebarPurchaseLotsStockInNotesIdEditRoute:
    AppAuthedSidebarPurchaseLotsStockInNotesIdEditRoute,
  AppAuthedSidebarPurchaseLotsStockOutNotesIdEditRoute:
    AppAuthedSidebarPurchaseLotsStockOutNotesIdEditRoute,
  AppAuthedSidebarSalesWarehouseStockInNotesIdEditRoute:
    AppAuthedSidebarSalesWarehouseStockInNotesIdEditRoute,
  AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRoute:
    AppAuthedSidebarSalesWarehouseStockOutNotesIdEditRoute,
  AppAuthedSidebarScentingWarehouseStockInNotesIdEditRoute:
    AppAuthedSidebarScentingWarehouseStockInNotesIdEditRoute,
  AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRoute:
    AppAuthedSidebarScentingWarehouseStockOutNotesIdEditRoute,
  AppAuthedSidebarSortingWarehouseStockInNotesIdEditRoute:
    AppAuthedSidebarSortingWarehouseStockInNotesIdEditRoute,
  AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRoute:
    AppAuthedSidebarSortingWarehouseStockOutNotesIdEditRoute,
}

const AppAuthedSidebarRouteWithChildren =
  AppAuthedSidebarRoute._addFileChildren(AppAuthedSidebarRouteChildren)

interface AppAuthedSaleRouteChildren {
  AppAuthedSaleDisplayRoute: typeof AppAuthedSaleDisplayRoute
  AppAuthedSaleIndexRoute: typeof AppAuthedSaleIndexRoute
}

const AppAuthedSaleRouteChildren: AppAuthedSaleRouteChildren = {
  AppAuthedSaleDisplayRoute: AppAuthedSaleDisplayRoute,
  AppAuthedSaleIndexRoute: AppAuthedSaleIndexRoute,
}

const AppAuthedSaleRouteWithChildren = AppAuthedSaleRoute._addFileChildren(
  AppAuthedSaleRouteChildren,
)

interface AppAuthedRouteChildren {
  AppAuthedSidebarRoute: typeof AppAuthedSidebarRouteWithChildren
  AppAuthedCustomerDisplayRoute: typeof AppAuthedCustomerDisplayRoute
  AppAuthedSaleRoute: typeof AppAuthedSaleRouteWithChildren
  AppAuthedStationRoute: typeof AppAuthedStationRoute
}

const AppAuthedRouteChildren: AppAuthedRouteChildren = {
  AppAuthedSidebarRoute: AppAuthedSidebarRouteWithChildren,
  AppAuthedCustomerDisplayRoute: AppAuthedCustomerDisplayRoute,
  AppAuthedSaleRoute: AppAuthedSaleRouteWithChildren,
  AppAuthedStationRoute: AppAuthedStationRoute,
}

const AppAuthedRouteWithChildren = AppAuthedRoute._addFileChildren(
  AppAuthedRouteChildren,
)

interface AppRouteChildren {
  AppAuthedRoute: typeof AppAuthedRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppAuthedRoute: AppAuthedRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  TraceCodeRoute: TraceCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
